/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BackfillInvoiceDto } from '../models';
// @ts-ignore
import type { BackfillInvoiceResponseDto } from '../models';
// @ts-ignore
import type { BroadcastAlertDto } from '../models';
// @ts-ignore
import type { BroadcastAlertResponseDto } from '../models';
// @ts-ignore
import type { CannedResponseListDto } from '../models';
// @ts-ignore
import type { CannedResponseWriteResultDto } from '../models';
// @ts-ignore
import type { ChangePasswordDto } from '../models';
// @ts-ignore
import type { CreateCannedResponseDto } from '../models';
// @ts-ignore
import type { CreateEmailSignatureDto } from '../models';
// @ts-ignore
import type { CreateOperatorDto } from '../models';
// @ts-ignore
import type { CreateVoucherRequestDto } from '../models';
// @ts-ignore
import type { DeactivateVoucherRequestDto } from '../models';
// @ts-ignore
import type { EmailSignatureDeleteResultDto } from '../models';
// @ts-ignore
import type { EmailSignatureListDto } from '../models';
// @ts-ignore
import type { EmailSignatureWriteResultDto } from '../models';
// @ts-ignore
import type { FailedJobsListDto } from '../models';
// @ts-ignore
import type { LoginDto } from '../models';
// @ts-ignore
import type { LoginResponseDto } from '../models';
// @ts-ignore
import type { OperatorAuditEntryDto } from '../models';
// @ts-ignore
import type { OperatorAuditListDto } from '../models';
// @ts-ignore
import type { OperatorDto } from '../models';
// @ts-ignore
import type { OperatorListDto } from '../models';
// @ts-ignore
import type { OperatorOneTimePasswordDto } from '../models';
// @ts-ignore
import type { OperatorReasonDto } from '../models';
// @ts-ignore
import type { OpsBillingDto } from '../models';
// @ts-ignore
import type { OpsBudgetInputDto } from '../models';
// @ts-ignore
import type { OpsBudgetListDto } from '../models';
// @ts-ignore
import type { OpsCashBalanceDto } from '../models';
// @ts-ignore
import type { OpsCashBalanceInputDto } from '../models';
// @ts-ignore
import type { OpsCashBalanceListDto } from '../models';
// @ts-ignore
import type { OpsCostItemDto } from '../models';
// @ts-ignore
import type { OpsCostItemInputDto } from '../models';
// @ts-ignore
import type { OpsCostItemListDto } from '../models';
// @ts-ignore
import type { OpsDatevInviteResendResultDto } from '../models';
// @ts-ignore
import type { OpsDatevOverviewDto } from '../models';
// @ts-ignore
import type { OpsDeleteResultDto } from '../models';
// @ts-ignore
import type { OpsDiagnosisDto } from '../models';
// @ts-ignore
import type { OpsDocumentActionResultDto } from '../models';
// @ts-ignore
import type { OpsDocumentKind } from '../models';
// @ts-ignore
import type { OpsDocumentListDto } from '../models';
// @ts-ignore
import type { OpsDocumentReissueDto } from '../models';
// @ts-ignore
import type { OpsDocumentReissuePreviewDto } from '../models';
// @ts-ignore
import type { OpsDocumentReissueResultDto } from '../models';
// @ts-ignore
import type { OpsDocumentResendDto } from '../models';
// @ts-ignore
import type { OpsEmailFilterStatus } from '../models';
// @ts-ignore
import type { OpsEmailLogDto } from '../models';
// @ts-ignore
import type { OpsFinanceReportDto } from '../models';
// @ts-ignore
import type { OpsFxRateDto } from '../models';
// @ts-ignore
import type { OpsFxRateInputDto } from '../models';
// @ts-ignore
import type { OpsFxRateListDto } from '../models';
// @ts-ignore
import type { OpsInfrastructureDto } from '../models';
// @ts-ignore
import type { OpsPartnerStatusDto } from '../models';
// @ts-ignore
import type { OpsPartnerSyncStartDto } from '../models';
// @ts-ignore
import type { OpsRecipientResendResultDto } from '../models';
// @ts-ignore
import type { OpsSmtpTestResultDto } from '../models';
// @ts-ignore
import type { OpsSmtpTestStatusDto } from '../models';
// @ts-ignore
import type { OpsVoucherListDto } from '../models';
// @ts-ignore
import type { OpsVoucherUsageListDto } from '../models';
// @ts-ignore
import type { OpsVoucherWriteResultDto } from '../models';
// @ts-ignore
import type { PeriodBackfillExecuteRequestDto } from '../models';
// @ts-ignore
import type { PeriodBackfillExecuteResultDto } from '../models';
// @ts-ignore
import type { PeriodBackfillPreviewDto } from '../models';
// @ts-ignore
import type { PeriodBackfillPreviewRequestDto } from '../models';
// @ts-ignore
import type { QueueDiscardAllResponseDto } from '../models';
// @ts-ignore
import type { QueueJobActionResponseDto } from '../models';
// @ts-ignore
import type { QueuePauseResponseDto } from '../models';
// @ts-ignore
import type { QueueRetryAllResponseDto } from '../models';
// @ts-ignore
import type { ResolveFailedJobResponseDto } from '../models';
// @ts-ignore
import type { ShopAccessGrantDto } from '../models';
// @ts-ignore
import type { ShopAccessRequestDto } from '../models';
// @ts-ignore
import type { ShopFileDto } from '../models';
// @ts-ignore
import type { ShopNumberingDto } from '../models';
// @ts-ignore
import type { ShopSearchResultDto } from '../models';
// @ts-ignore
import type { TrialExtensionRequestDto } from '../models';
// @ts-ignore
import type { TrialExtensionResultDto } from '../models';
// @ts-ignore
import type { UpdateCannedResponseDto } from '../models';
// @ts-ignore
import type { UpdateEmailSignatureDto } from '../models';
// @ts-ignore
import type { UpdateOperatorDto } from '../models';
// @ts-ignore
import type { UpdateShopNumberingDto } from '../models';
// @ts-ignore
import type { UpdateShopNumberingResponseDto } from '../models';
/**
 * InternalAdminApi - axios parameter creator
 * @export
 */
export const InternalAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Archive a canned response (audited)
         * @param {string} id SupportCannedResponse id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCannedResponse: async (id: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveCannedResponse', 'id', id)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('archiveCannedResponse', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/canned-responses/{id}/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the order from Shopify, runs the standard invoice creation pipeline (same calculation audit, same PDF generation), consumes the supplied invoice number, and writes an OperatorAuditLog row. Operator-only.
         * @summary Backfill an invoice for an order whose webhook was lost
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {BackfillInvoiceDto} backfillInvoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfillInvoice: async (shopId: string, xOpsShopAccess: string, backfillInvoiceDto: BackfillInvoiceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('backfillInvoice', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('backfillInvoice', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'backfillInvoiceDto' is not null or undefined
            assertParamExists('backfillInvoice', 'backfillInvoiceDto', backfillInvoiceDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/invoices/backfill`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backfillInvoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates one in-app Alert per targeted shop, rendered in that shop’s Shop.locale from operator-supplied per-locale copy. Deduped by `broadcast:<broadcastKey>`; supports a dry run. Operator-only.
         * @summary Broadcast a custom system alert to merchants, in each shop’s language
         * @param {BroadcastAlertDto} broadcastAlertDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        broadcastAlert: async (broadcastAlertDto: BroadcastAlertDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'broadcastAlertDto' is not null or undefined
            assertParamExists('broadcastAlert', 'broadcastAlertDto', broadcastAlertDto)
            const localVarPath = `/v1/internal-admin/alerts/broadcast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(broadcastAlertDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a month’s rate (audited)
         * @param {string} month YYYY-MM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOpsFxRate: async (month: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('clearOpsFxRate', 'month', month)
            const localVarPath = `/v1/internal-admin/operations/fx-rates/{month}`
                .replace(`{${"month"}}`, encodeURIComponent(String(month)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a canned response (audited)
         * @param {CreateCannedResponseDto} createCannedResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCannedResponse: async (createCannedResponseDto: CreateCannedResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCannedResponseDto' is not null or undefined
            assertParamExists('createCannedResponse', 'createCannedResponseDto', createCannedResponseDto)
            const localVarPath = `/v1/internal-admin/canned-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCannedResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save a new email signature (audited)
         * @param {CreateEmailSignatureDto} createEmailSignatureDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailSignature: async (createEmailSignatureDto: CreateEmailSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailSignatureDto' is not null or undefined
            assertParamExists('createEmailSignature', 'createEmailSignatureDto', createEmailSignatureDto)
            const localVarPath = `/v1/internal-admin/email-signatures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an operator (audited) — returns a one-time password
         * @param {CreateOperatorDto} createOperatorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperator: async (createOperatorDto: CreateOperatorDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOperatorDto' is not null or undefined
            assertParamExists('createOperator', 'createOperatorDto', createOperatorDto)
            const localVarPath = `/v1/internal-admin/operators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOperatorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record a cash balance (audited)
         * @param {OpsCashBalanceInputDto} opsCashBalanceInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpsCashBalance: async (opsCashBalanceInputDto: OpsCashBalanceInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opsCashBalanceInputDto' is not null or undefined
            assertParamExists('createOpsCashBalance', 'opsCashBalanceInputDto', opsCashBalanceInputDto)
            const localVarPath = `/v1/internal-admin/operations/cash-balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opsCashBalanceInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a cost item (audited)
         * @param {OpsCostItemInputDto} opsCostItemInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpsCostItem: async (opsCostItemInputDto: OpsCostItemInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opsCostItemInputDto' is not null or undefined
            assertParamExists('createOpsCostItem', 'opsCostItemInputDto', opsCostItemInputDto)
            const localVarPath = `/v1/internal-admin/operations/costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opsCostItemInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies to subscriptions created AFTER this point only — the discount rides appSubscriptionCreate.
         * @summary Create a voucher code (audited)
         * @param {CreateVoucherRequestDto} createVoucherRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpsVoucher: async (createVoucherRequestDto: CreateVoucherRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createVoucherRequestDto' is not null or undefined
            assertParamExists('createOpsVoucher', 'createVoucherRequestDto', createVoucherRequestDto)
            const localVarPath = `/v1/internal-admin/vouchers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVoucherRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stops new redemptions. Subscriptions that already carry the discount keep it. The code is never deleted: its usage rows would cascade away.
         * @summary Deactivate a voucher code (audited)
         * @param {string} id VoucherCode id
         * @param {DeactivateVoucherRequestDto} deactivateVoucherRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateOpsVoucher: async (id: string, deactivateVoucherRequestDto: DeactivateVoucherRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateOpsVoucher', 'id', id)
            // verify required parameter 'deactivateVoucherRequestDto' is not null or undefined
            assertParamExists('deactivateOpsVoucher', 'deactivateVoucherRequestDto', deactivateVoucherRequestDto)
            const localVarPath = `/v1/internal-admin/vouchers/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deactivateVoucherRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a saved email signature (audited)
         * @param {string} id EmailSignature id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailSignature: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEmailSignature', 'id', id)
            const localVarPath = `/v1/internal-admin/email-signatures/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a cash balance (audited)
         * @param {string} id FinanceCashBalance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpsCashBalance: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOpsCashBalance', 'id', id)
            const localVarPath = `/v1/internal-admin/operations/cash-balances/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For mistakes. A cancelled cost gets an end month instead, so past months stay.
         * @summary Delete a cost item (audited)
         * @param {string} id FinanceCostItem id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpsCostItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOpsCostItem', 'id', id)
            const localVarPath = `/v1/internal-admin/operations/costs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Traces the order through webhook events, attention items, durable failed jobs and its documents, reads the shop state and the order from Shopify, and returns one verdict token plus exactly one next action for the invoice family and for the refund/cancellation family. Writes an OperatorAuditLog row (order.diagnosis.view).
         * @summary Diagnose why an order has or lacks its invoice, credit note or Storno
         * @param {string} shopId Shop id
         * @param {string} order An order name (&#x60;#1234&#x60;, &#x60;1234&#x60;, or a custom-prefixed name as Shopify prints it), a numeric Shopify order id, or an order gid.
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnoseOpsOrder: async (shopId: string, order: string, xOpsShopAccess: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('diagnoseOpsOrder', 'shopId', shopId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('diagnoseOpsOrder', 'order', order)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('diagnoseOpsOrder', 'xOpsShopAccess', xOpsShopAccess)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/diagnosis`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable an operator (audited)
         * @param {string} username 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableOperator: async (username: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('disableOperator', 'username', username)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('disableOperator', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/operators/{username}/disable`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The stored bytes, decrypted, exactly as archived. Writes document.pdf.download to the operator audit log first.
         * @summary Download a document’s archived PDF (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {DownloadOpsShopDocumentPdfKindEnum} kind 
         * @param {string} documentId Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOpsShopDocumentPdf: async (xOpsShopAccess: string, shopId: string, kind: DownloadOpsShopDocumentPdfKindEnum, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('downloadOpsShopDocumentPdf', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('downloadOpsShopDocumentPdf', 'shopId', shopId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('downloadOpsShopDocumentPdf', 'kind', kind)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('downloadOpsShopDocumentPdf', 'documentId', documentId)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/documents/{kind}/{documentId}/pdf`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-enable an operator (audited)
         * @param {string} username 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableOperator: async (username: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('enableOperator', 'username', username)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('enableOperator', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/operators/{username}/enable`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Writes a durable OperatorAuditLog row, then re-checks each order against fresh data with the gap predicate and mints it through the single invoice writer (next sequential number, Rechnungsdatum = processed_at). Customer email is off unless sendCustomerEmail is true. At most 25 orders per call. Raises one merchant notice naming the period the new invoices are dated in.
         * @summary Mint invoices for previewed orders (audited)
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {PeriodBackfillExecuteRequestDto} periodBackfillExecuteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeOpsPeriodBackfill: async (shopId: string, xOpsShopAccess: string, periodBackfillExecuteRequestDto: PeriodBackfillExecuteRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('executeOpsPeriodBackfill', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('executeOpsPeriodBackfill', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'periodBackfillExecuteRequestDto' is not null or undefined
            assertParamExists('executeOpsPeriodBackfill', 'periodBackfillExecuteRequestDto', periodBackfillExecuteRequestDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/period-backfill/execute`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(periodBackfillExecuteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calls Shopify appSubscriptionTrialExtend for the shop\'s ACTIVE subscription while it is still in trial, at most 30 days per action. Writes the audit row before Shopify is called. A Shopify refusal (userErrors) is returned with extended=false, not thrown.
         * @summary Extend a running trial (audited)
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {TrialExtensionRequestDto} trialExtensionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendOpsShopTrial: async (shopId: string, xOpsShopAccess: string, trialExtensionRequestDto: TrialExtensionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('extendOpsShopTrial', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('extendOpsShopTrial', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'trialExtensionRequestDto' is not null or undefined
            assertParamExists('extendOpsShopTrial', 'trialExtensionRequestDto', trialExtensionRequestDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/billing/trial-extension`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialExtensionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read one operator audit entry including its payload
         * @param {string} id OperatorAuditLog id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorAuditEntry: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOperatorAuditEntry', 'id', id)
            const localVarPath = `/v1/internal-admin/audit-log/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * EUR, accrual. Default range: the last 12 months including the running one; at most 36 months.
         * @summary Operations report: P&L, SaaS metrics, unit economics, plan, runway
         * @param {string} [from] First month, YYYY-MM.
         * @param {string} [to] Last month, YYYY-MM.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsFinanceReport: async (from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/operations/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The snapshot the collector builds every 15 s. Poll at most every 15 s; it never changes faster.
         * @summary Infrastructure: nodes, Load Balancer, database connection budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsInfrastructure: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/infrastructure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Partner API mirror status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsPartnerSyncStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/operations/partner-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Local subscription (both slots, cap, trial), trial-extension eligibility, TrialHistory, recent billing cycles, failed usage records, redeemed vouchers, subscription transition audit and earlier operator billing actions. DB only.
         * @summary Read a shop\'s billing detail
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsShopBilling: async (shopId: string, xOpsShopAccess: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('getOpsShopBilling', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('getOpsShopBilling', 'xOpsShopAccess', xOpsShopAccess)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/billing`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Settings summary and lock state (no secrets), every Steuerberater invite (never the token hash), every export schedule with its recipients and their confirmation state — distinguishing a double-opt-in confirmation from a recipient the Kanzlei’s finalise created CONFIRMED — and the latest DATEV EXTF export jobs.
         * @summary Read a shop\'s DATEV invite, export recipients and last exports
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsShopDatev: async (shopId: string, xOpsShopAccess: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('getOpsShopDatev', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('getOpsShopDatev', 'xOpsShopAccess', xOpsShopAccess)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/datev`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Identity, subscription, contract acceptance, setup, Shopify scope approval, open alerts and attention items, recent webhooks, documents, exports and tickets. Sections that cannot be read are null and named in `unavailable`.
         * @summary Read a shop file
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsShopFile: async (shopId: string, xOpsShopAccess: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('getOpsShopFile', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('getOpsShopFile', 'xOpsShopAccess', xOpsShopAccess)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/file`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * queued while the worker runs it, then completed (the server accepted it — check your inbox) or failed (with the classified reason).
         * @summary Poll an SMTP test mail
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} jobId From sendOpsShopSmtpTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsShopSmtpTestStatus: async (xOpsShopAccess: string, shopId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('getOpsShopSmtpTestStatus', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('getOpsShopSmtpTestStatus', 'shopId', shopId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getOpsShopSmtpTestStatus', 'jobId', jobId)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/smtp-test/{jobId}`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)))
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a shop’s document numbering state
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopNumbering: async (shopId: string, xOpsShopAccess: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('getShopNumbering', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('getShopNumbering', 'xOpsShopAccess', xOpsShopAccess)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/numbering`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change an operator password — returns a fresh bearer token
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerChangePasswordV1: async (changePasswordDto: ChangePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordDto' is not null or undefined
            assertParamExists('internalAdminControllerChangePasswordV1', 'changePasswordDto', changePasswordDto)
            const localVarPath = `/v1/internal-admin/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Discard all failed jobs in a queue (audited, reason required)
         * @param {string} name 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerDiscardAllV1: async (name: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('internalAdminControllerDiscardAllV1', 'name', name)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('internalAdminControllerDiscardAllV1', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/queues/{name}/discard-all`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Discard (delete) a specific job (audited, reason required)
         * @param {string} name 
         * @param {string} id 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerDiscardJobV1: async (name: string, id: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('internalAdminControllerDiscardJobV1', 'name', name)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalAdminControllerDiscardJobV1', 'id', id)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('internalAdminControllerDiscardJobV1', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/queues/{name}/jobs/{id}/discard`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all queue statistics and health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerGetAllQueuesV1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/queues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get full job detail including stacktrace
         * @param {string} name 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerGetJobV1: async (name: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('internalAdminControllerGetJobV1', 'name', name)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalAdminControllerGetJobV1', 'id', id)
            const localVarPath = `/v1/internal-admin/queues/{name}/jobs/{id}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List jobs by state with pagination
         * @param {string} name 
         * @param {string} [shopId] Filter by shop ID or domain
         * @param {string} [search] Search by job name, ID, error, or data preview
         * @param {string} [limit] Items per page (max 100)
         * @param {string} [page] Page number (1-based)
         * @param {InternalAdminControllerGetJobsV1StateEnum} [state] Job state filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerGetJobsV1: async (name: string, shopId?: string, search?: string, limit?: string, page?: string, state?: InternalAdminControllerGetJobsV1StateEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('internalAdminControllerGetJobsV1', 'name', name)
            const localVarPath = `/v1/internal-admin/queues/{name}/jobs`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (shopId !== undefined) {
                localVarQueryParameter['shopId'] = shopId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get rolling 24h metrics history for charts
         * @param {string} [minutes] Number of minutes of history (1–1440, default 60)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerGetMetricsHistoryV1: async (minutes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/metrics/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minutes !== undefined) {
                localVarQueryParameter['minutes'] = minutes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the persistent FailedJob table (survives BullMQ removeOnFail eviction). Unresolved-only by default. Operator-only.
         * @summary List durable terminally-failed jobs
         * @param {InternalAdminControllerListFailedJobsV1QueueNameEnum} [queueName] Filter by queue name.
         * @param {string} [shopId] Filter by shop ID (best-effort field; some jobs have no shop).
         * @param {boolean} [includeResolved] Whether to include already-resolved records. Defaults to false (unresolved only).
         * @param {number} [page] Page number (1-based).
         * @param {number} [limit] Items per page (max 100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerListFailedJobsV1: async (queueName?: InternalAdminControllerListFailedJobsV1QueueNameEnum, shopId?: string, includeResolved?: boolean, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/failed-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (queueName !== undefined) {
                localVarQueryParameter['queueName'] = queueName;
            }

            if (shopId !== undefined) {
                localVarQueryParameter['shopId'] = shopId;
            }

            if (includeResolved !== undefined) {
                localVarQueryParameter['includeResolved'] = includeResolved;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin login — returns a signed bearer token
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerLoginV1: async (loginDto: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('internalAdminControllerLoginV1', 'loginDto', loginDto)
            const localVarPath = `/v1/internal-admin/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pause a queue (audited, reason required)
         * @param {string} name 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerPauseV1: async (name: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('internalAdminControllerPauseV1', 'name', name)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('internalAdminControllerPauseV1', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/queues/{name}/pause`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve (clear) a durable failed-job record (audited, reason required)
         * @param {string} id FailedJob record id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerResolveFailedJobV1: async (id: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalAdminControllerResolveFailedJobV1', 'id', id)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('internalAdminControllerResolveFailedJobV1', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/failed-jobs/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resume a paused queue (audited, reason required)
         * @param {string} name 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerResumeV1: async (name: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('internalAdminControllerResumeV1', 'name', name)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('internalAdminControllerResumeV1', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/queues/{name}/resume`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry all failed jobs in a queue (audited, reason required)
         * @param {string} name 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerRetryAllV1: async (name: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('internalAdminControllerRetryAllV1', 'name', name)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('internalAdminControllerRetryAllV1', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/queues/{name}/retry-all`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry a specific job (audited, reason required)
         * @param {string} name 
         * @param {string} id 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerRetryJobV1: async (name: string, id: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('internalAdminControllerRetryJobV1', 'name', name)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalAdminControllerRetryJobV1', 'id', id)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('internalAdminControllerRetryJobV1', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/queues/{name}/jobs/{id}/retry`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the live subscription from Shopify Admin API and replays the webhook update handler to reconcile local DB. Operator-only (HMAC token from /internal-admin/auth/login).
         * @summary Force-sync subscription from Shopify
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerSyncSubscriptionFromShopifyV1: async (shopId: string, xOpsShopAccess: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('internalAdminControllerSyncSubscriptionFromShopifyV1', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('internalAdminControllerSyncSubscriptionFromShopifyV1', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('internalAdminControllerSyncSubscriptionFromShopifyV1', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/subscription/sync`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Active snippets by default; includeArchived adds archived ones. A category returns the snippets for that ticket category plus those that fit any. Shipped defaults that are missing are inserted first; an operator-edited default is never overwritten.
         * @summary List canned responses
         * @param {boolean} [includeArchived] Include archived snippets (the management page). The picker leaves this off.
         * @param {ListCannedResponsesCategoryEnum} [category] Only snippets for this ticket category, plus those that fit any category (category null).
         * @param {string} [q] Case-insensitive search over title and both bodies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCannedResponses: async (includeArchived?: boolean, category?: ListCannedResponsesCategoryEnum, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/canned-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List saved email signatures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailSignatures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/email-signatures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Filter by operator, action, shop domain and date. Payloads are not included — open one entry to read its payload (that read is itself audited).
         * @summary List operator audit entries
         * @param {string} [operator] 
         * @param {string} [action] 
         * @param {string} [shopDomain] Exact shop domain, or &#x60;*&#x60; for cross-shop actions.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperatorAudit: async (operator?: string, action?: string, shopDomain?: string, from?: string, to?: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/audit-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (operator !== undefined) {
                localVarQueryParameter['operator'] = operator;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (shopDomain !== undefined) {
                localVarQueryParameter['shopDomain'] = shopDomain;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List operators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperators: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/operators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List plan figures of a year
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsBudgets: async (year: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('listOpsBudgets', 'year', year)
            const localVarPath = `/v1/internal-admin/operations/budgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List cash balances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsCashBalances: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/operations/cash-balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List cost items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsCostItems: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/operations/costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List stored USD→EUR month rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsFxRates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/operations/fx-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Newest first across invoices, credit notes and cancellation invoices, 25 per page. With q, the support document lookup (document number, order name or order id) — unpaged, capped, and `truncated` says so.
         * @summary List or search a shop’s documents
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} [q] A document number as the merchant quoted it (RE-26392, 26392), an order name (#1001) or an order id. Uses the support document lookup; paging does not apply to a search.
         * @param {OpsDocumentKind} [kind] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsShopDocuments: async (xOpsShopAccess: string, shopId: string, q?: string, kind?: OpsDocumentKind, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('listOpsShopDocuments', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('listOpsShopDocuments', 'shopId', shopId)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/documents`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Document and export mail only — `notLogged` names the mail that never creates a row. SENT means the relay accepted the message, not that it arrived; bounces are not recorded.
         * @summary Read a shop’s email delivery log
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} [recipient] Part of the recipient address (case-insensitive).
         * @param {OpsEmailFilterStatus} [status] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsShopEmailLog: async (xOpsShopAccess: string, shopId: string, recipient?: string, status?: OpsEmailFilterStatus, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('listOpsShopEmailLog', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('listOpsShopEmailLog', 'shopId', shopId)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/email-log`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (recipient !== undefined) {
                localVarQueryParameter['recipient'] = recipient;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shop identity, subscription id and date only. onCurrentSubscription tells whether the discount is still on the shop’s subscription.
         * @summary List the shops that redeemed a voucher code
         * @param {string} id VoucherCode id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsVoucherUsages: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listOpsVoucherUsages', 'id', id)
            const localVarPath = `/v1/internal-admin/vouchers/{id}/usages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Newest first, with the currentUsage counter AND the usage-row count (both can under-count). Fixed amounts are in billingCurrency (USD).
         * @summary List voucher codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsVouchers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/vouchers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Writes an OperatorAuditLog row with the reason or the ticket, and returns a grant valid for two hours. Every read of the shop requires the grant in the X-Ops-Shop-Access header.
         * @summary Open a shop with a reason (audited)
         * @param {string} shopId Shop id or myshopify domain
         * @param {ShopAccessRequestDto} shopAccessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openOpsShopAccess: async (shopId: string, shopAccessRequestDto: ShopAccessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('openOpsShopAccess', 'shopId', shopId)
            // verify required parameter 'shopAccessRequestDto' is not null or undefined
            assertParamExists('openOpsShopAccess', 'shopAccessRequestDto', shopAccessRequestDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/access`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopAccessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the paid orders in the period that the daily reconciliation would call a gap (the SAME predicate), the orders it leaves alone grouped by reason, whether the scan was truncated, and the window actually scanned (clamped to Shopify’s 60-day read window and to the invoicing anchor). Returns a preview token that arms execute for 15 minutes.
         * @summary Preview a period backfill (dry run)
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {PeriodBackfillPreviewRequestDto} periodBackfillPreviewRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOpsPeriodBackfill: async (shopId: string, xOpsShopAccess: string, periodBackfillPreviewRequestDto: PeriodBackfillPreviewRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('previewOpsPeriodBackfill', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('previewOpsPeriodBackfill', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'periodBackfillPreviewRequestDto' is not null or undefined
            assertParamExists('previewOpsPeriodBackfill', 'periodBackfillPreviewRequestDto', periodBackfillPreviewRequestDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/period-backfill/preview`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(periodBackfillPreviewRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The next two free invoice numbers (Storno, then the new invoice) and the refusal the reissue would answer with. Reserves nothing; another document minted in between moves the numbers.
         * @summary Preview a reissue: the numbers it would draw and any refusal
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} documentId Invoice id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOpsShopInvoiceReissue: async (xOpsShopAccess: string, shopId: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('previewOpsShopInvoiceReissue', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('previewOpsShopInvoiceReissue', 'shopId', shopId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('previewOpsShopInvoiceReissue', 'documentId', documentId)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/documents/invoice/{documentId}/reissue-preview`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only for a document with NO stored PDF. An archived PDF is never re-rendered (§147 AO) — resend it instead.
         * @summary Regenerate a missing PDF (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {RegenerateOpsShopDocumentKindEnum} kind 
         * @param {string} documentId Document id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateOpsShopDocument: async (xOpsShopAccess: string, shopId: string, kind: RegenerateOpsShopDocumentKindEnum, documentId: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('regenerateOpsShopDocument', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('regenerateOpsShopDocument', 'shopId', shopId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('regenerateOpsShopDocument', 'kind', kind)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('regenerateOpsShopDocument', 'documentId', documentId)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('regenerateOpsShopDocument', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/documents/{kind}/{documentId}/regenerate`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-reads the order from Shopify, writes a Stornorechnung for the ACTIVE immutable invoice and a new invoice through the normal correction pipeline, in one transaction and the gapless sequence. Works for a document that was never emailed (CREATED with an archived PDF). An optional customer VAT ID is format-checked, stored on the customer and printed on the new invoice. The Shopify order is never changed. Both documents then go through the normal PDF and email jobs.
         * @summary Reissue an invoice: Storno plus a new invoice from the current order (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} documentId Invoice id
         * @param {OpsDocumentReissueDto} opsDocumentReissueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueOpsShopInvoice: async (xOpsShopAccess: string, shopId: string, documentId: string, opsDocumentReissueDto: OpsDocumentReissueDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('reissueOpsShopInvoice', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('reissueOpsShopInvoice', 'shopId', shopId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('reissueOpsShopInvoice', 'documentId', documentId)
            // verify required parameter 'opsDocumentReissueDto' is not null or undefined
            assertParamExists('reissueOpsShopInvoice', 'opsDocumentReissueDto', opsDocumentReissueDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/documents/invoice/{documentId}/reissue`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opsDocumentReissueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Same path as the merchant\'s resend: mints a NEW token, so the Kanzlei\'s previous link stops working even if this send fails. Only the shop\'s newest PENDING invite is resendable. A successful send closes DATEV_INVITE_UNDELIVERED by itself. Rate-limited per shop.
         * @summary Resend the pending Steuerberater invite (audited)
         * @param {string} shopId Shop id
         * @param {string} inviteId DatevAccountantInvite id
         * @param {string} xOpsShopAccess 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOpsDatevInvite: async (shopId: string, inviteId: string, xOpsShopAccess: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('resendOpsDatevInvite', 'shopId', shopId)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('resendOpsDatevInvite', 'inviteId', inviteId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('resendOpsDatevInvite', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('resendOpsDatevInvite', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/datev/invites/{inviteId}/resend`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)))
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Same path as the merchant\'s resend: rotates the confirmation token, so the recipient\'s earlier link stops working. PENDING and EXPIRED recipients only — a CONFIRMED one would be reset to pending, a REJECTED one declined. Rate-limited per shop.
         * @summary Resend an export recipient\'s confirmation email (audited)
         * @param {string} shopId Shop id
         * @param {string} recipientId ScheduleRecipient id
         * @param {string} xOpsShopAccess 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOpsRecipientConfirmation: async (shopId: string, recipientId: string, xOpsShopAccess: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('resendOpsRecipientConfirmation', 'shopId', shopId)
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('resendOpsRecipientConfirmation', 'recipientId', recipientId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('resendOpsRecipientConfirmation', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('resendOpsRecipientConfirmation', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/datev/recipients/{recipientId}/resend-confirmation`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)))
                .replace(`{${"recipientId"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Queues the merchant’s own resend of the ARCHIVED PDF. recipientOverride needs the ticketId of a support ticket of this shop. Refused for a document the shop is holding for its own first send (automatic sending off). A failed send still raises the merchant’s own failure alert.
         * @summary Resend a document email (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {ResendOpsShopDocumentKindEnum} kind 
         * @param {string} documentId Document id
         * @param {OpsDocumentResendDto} opsDocumentResendDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOpsShopDocument: async (xOpsShopAccess: string, shopId: string, kind: ResendOpsShopDocumentKindEnum, documentId: string, opsDocumentResendDto: OpsDocumentResendDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('resendOpsShopDocument', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('resendOpsShopDocument', 'shopId', shopId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('resendOpsShopDocument', 'kind', kind)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('resendOpsShopDocument', 'documentId', documentId)
            // verify required parameter 'opsDocumentResendDto' is not null or undefined
            assertParamExists('resendOpsShopDocument', 'opsDocumentResendDto', opsDocumentResendDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/documents/{kind}/{documentId}/resend`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opsDocumentResendDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset an operator password (audited) — returns a one-time password
         * @param {string} username 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOperatorPassword: async (username: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('resetOperatorPassword', 'username', username)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('resetOperatorPassword', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/operators/{username}/reset-password`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restore an archived canned response (audited)
         * @param {string} id SupportCannedResponse id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreCannedResponse: async (id: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreCannedResponse', 'id', id)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('restoreCannedResponse', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/canned-responses/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns identity only (domain, name, which field matched). Opening a shop needs a reason — see openOpsShopAccess.
         * @summary Find shops by domain, name or email
         * @param {string} q Part of a shop domain, shop name or legal name, or an email the shop uses (support, SMTP sender, a staff login).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOpsShops: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchOpsShops', 'q', q)
            const localVarPath = `/v1/internal-admin/shops/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The worker sends an export-shaped test through the merchant’s SMTP to YOUR operator address — never to anyone else, and without the connection probe that writes an error onto the merchant’s settings. Not applicable on our fallback relay or without a complete SMTP configuration.
         * @summary Send an SMTP test mail to yourself (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOpsShopSmtpTest: async (xOpsShopAccess: string, shopId: string, operatorReasonDto: OperatorReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('sendOpsShopSmtpTest', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('sendOpsShopSmtpTest', 'shopId', shopId)
            // verify required parameter 'operatorReasonDto' is not null or undefined
            assertParamExists('sendOpsShopSmtpTest', 'operatorReasonDto', operatorReasonDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/smtp-test`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A null amount removes the figure. Returns the whole year.
         * @summary Set or clear one plan figure (audited)
         * @param {OpsBudgetInputDto} opsBudgetInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpsBudget: async (opsBudgetInputDto: OpsBudgetInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opsBudgetInputDto' is not null or undefined
            assertParamExists('setOpsBudget', 'opsBudgetInputDto', opsBudgetInputDto)
            const localVarPath = `/v1/internal-admin/operations/budgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opsBudgetInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stored as MANUAL; an ECB fetch never replaces it.
         * @summary Override a month’s USD→EUR rate (audited)
         * @param {string} month YYYY-MM
         * @param {OpsFxRateInputDto} opsFxRateInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpsFxRate: async (month: string, opsFxRateInputDto: OpsFxRateInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('setOpsFxRate', 'month', month)
            // verify required parameter 'opsFxRateInputDto' is not null or undefined
            assertParamExists('setOpsFxRate', 'opsFxRateInputDto', opsFxRateInputDto)
            const localVarPath = `/v1/internal-admin/operations/fx-rates/{month}`
                .replace(`{${"month"}}`, encodeURIComponent(String(month)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opsFxRateInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Runs in the background; poll the status. Idempotent — a re-pull changes nothing.
         * @summary Pull the Partner API now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOpsPartnerSync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal-admin/operations/partner-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
         * @summary Edit a canned response (audited, optimistic concurrency)
         * @param {string} id SupportCannedResponse id
         * @param {UpdateCannedResponseDto} updateCannedResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCannedResponse: async (id: string, updateCannedResponseDto: UpdateCannedResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCannedResponse', 'id', id)
            // verify required parameter 'updateCannedResponseDto' is not null or undefined
            assertParamExists('updateCannedResponse', 'updateCannedResponseDto', updateCannedResponseDto)
            const localVarPath = `/v1/internal-admin/canned-responses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCannedResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the whole content. expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
         * @summary Save an edited email signature (audited, optimistic concurrency)
         * @param {string} id EmailSignature id
         * @param {UpdateEmailSignatureDto} updateEmailSignatureDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSignature: async (id: string, updateEmailSignatureDto: UpdateEmailSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmailSignature', 'id', id)
            // verify required parameter 'updateEmailSignatureDto' is not null or undefined
            assertParamExists('updateEmailSignature', 'updateEmailSignatureDto', updateEmailSignatureDto)
            const localVarPath = `/v1/internal-admin/email-signatures/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an operator profile (audited)
         * @param {string} username 
         * @param {UpdateOperatorDto} updateOperatorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperator: async (username: string, updateOperatorDto: UpdateOperatorDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('updateOperator', 'username', username)
            // verify required parameter 'updateOperatorDto' is not null or undefined
            assertParamExists('updateOperator', 'updateOperatorDto', updateOperatorDto)
            const localVarPath = `/v1/internal-admin/operators/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperatorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restates every month the item ran in. To record a price change, end the item and start a new one.
         * @summary Edit a cost item (audited)
         * @param {string} id FinanceCostItem id
         * @param {OpsCostItemInputDto} opsCostItemInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOpsCostItem: async (id: string, opsCostItemInputDto: OpsCostItemInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOpsCostItem', 'id', id)
            // verify required parameter 'opsCostItemInputDto' is not null or undefined
            assertParamExists('updateOpsCostItem', 'opsCostItemInputDto', opsCostItemInputDto)
            const localVarPath = `/v1/internal-admin/operations/costs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opsCostItemInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change a shop’s onboarding-frozen document numbering
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {UpdateShopNumberingDto} updateShopNumberingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShopNumbering: async (shopId: string, xOpsShopAccess: string, updateShopNumberingDto: UpdateShopNumberingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('updateShopNumbering', 'shopId', shopId)
            // verify required parameter 'xOpsShopAccess' is not null or undefined
            assertParamExists('updateShopNumbering', 'xOpsShopAccess', xOpsShopAccess)
            // verify required parameter 'updateShopNumberingDto' is not null or undefined
            assertParamExists('updateShopNumbering', 'updateShopNumberingDto', updateShopNumberingDto)
            const localVarPath = `/v1/internal-admin/shops/{shopId}/numbering`
                .replace(`{${"shopId"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOpsShopAccess != null) {
                localVarHeaderParameter['x-ops-shop-access'] = String(xOpsShopAccess);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShopNumberingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalAdminApi - functional programming interface
 * @export
 */
export const InternalAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Archive a canned response (audited)
         * @param {string} id SupportCannedResponse id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveCannedResponse(id: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CannedResponseWriteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveCannedResponse(id, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.archiveCannedResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches the order from Shopify, runs the standard invoice creation pipeline (same calculation audit, same PDF generation), consumes the supplied invoice number, and writes an OperatorAuditLog row. Operator-only.
         * @summary Backfill an invoice for an order whose webhook was lost
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {BackfillInvoiceDto} backfillInvoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backfillInvoice(shopId: string, xOpsShopAccess: string, backfillInvoiceDto: BackfillInvoiceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackfillInvoiceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backfillInvoice(shopId, xOpsShopAccess, backfillInvoiceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.backfillInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates one in-app Alert per targeted shop, rendered in that shop’s Shop.locale from operator-supplied per-locale copy. Deduped by `broadcast:<broadcastKey>`; supports a dry run. Operator-only.
         * @summary Broadcast a custom system alert to merchants, in each shop’s language
         * @param {BroadcastAlertDto} broadcastAlertDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async broadcastAlert(broadcastAlertDto: BroadcastAlertDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BroadcastAlertResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.broadcastAlert(broadcastAlertDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.broadcastAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a month’s rate (audited)
         * @param {string} month YYYY-MM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearOpsFxRate(month: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDeleteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearOpsFxRate(month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.clearOpsFxRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a canned response (audited)
         * @param {CreateCannedResponseDto} createCannedResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCannedResponse(createCannedResponseDto: CreateCannedResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CannedResponseWriteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCannedResponse(createCannedResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.createCannedResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save a new email signature (audited)
         * @param {CreateEmailSignatureDto} createEmailSignatureDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmailSignature(createEmailSignatureDto: CreateEmailSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailSignatureWriteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmailSignature(createEmailSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.createEmailSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an operator (audited) — returns a one-time password
         * @param {CreateOperatorDto} createOperatorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOperator(createOperatorDto: CreateOperatorDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorOneTimePasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOperator(createOperatorDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.createOperator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record a cash balance (audited)
         * @param {OpsCashBalanceInputDto} opsCashBalanceInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOpsCashBalance(opsCashBalanceInputDto: OpsCashBalanceInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsCashBalanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOpsCashBalance(opsCashBalanceInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.createOpsCashBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a cost item (audited)
         * @param {OpsCostItemInputDto} opsCostItemInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOpsCostItem(opsCostItemInputDto: OpsCostItemInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsCostItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOpsCostItem(opsCostItemInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.createOpsCostItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies to subscriptions created AFTER this point only — the discount rides appSubscriptionCreate.
         * @summary Create a voucher code (audited)
         * @param {CreateVoucherRequestDto} createVoucherRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOpsVoucher(createVoucherRequestDto: CreateVoucherRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsVoucherWriteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOpsVoucher(createVoucherRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.createOpsVoucher']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stops new redemptions. Subscriptions that already carry the discount keep it. The code is never deleted: its usage rows would cascade away.
         * @summary Deactivate a voucher code (audited)
         * @param {string} id VoucherCode id
         * @param {DeactivateVoucherRequestDto} deactivateVoucherRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateOpsVoucher(id: string, deactivateVoucherRequestDto: DeactivateVoucherRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsVoucherWriteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateOpsVoucher(id, deactivateVoucherRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.deactivateOpsVoucher']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a saved email signature (audited)
         * @param {string} id EmailSignature id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmailSignature(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailSignatureDeleteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmailSignature(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.deleteEmailSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a cash balance (audited)
         * @param {string} id FinanceCashBalance id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOpsCashBalance(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDeleteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOpsCashBalance(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.deleteOpsCashBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For mistakes. A cancelled cost gets an end month instead, so past months stay.
         * @summary Delete a cost item (audited)
         * @param {string} id FinanceCostItem id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOpsCostItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDeleteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOpsCostItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.deleteOpsCostItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Traces the order through webhook events, attention items, durable failed jobs and its documents, reads the shop state and the order from Shopify, and returns one verdict token plus exactly one next action for the invoice family and for the refund/cancellation family. Writes an OperatorAuditLog row (order.diagnosis.view).
         * @summary Diagnose why an order has or lacks its invoice, credit note or Storno
         * @param {string} shopId Shop id
         * @param {string} order An order name (&#x60;#1234&#x60;, &#x60;1234&#x60;, or a custom-prefixed name as Shopify prints it), a numeric Shopify order id, or an order gid.
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async diagnoseOpsOrder(shopId: string, order: string, xOpsShopAccess: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDiagnosisDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.diagnoseOpsOrder(shopId, order, xOpsShopAccess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.diagnoseOpsOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disable an operator (audited)
         * @param {string} username 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableOperator(username: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableOperator(username, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.disableOperator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The stored bytes, decrypted, exactly as archived. Writes document.pdf.download to the operator audit log first.
         * @summary Download a document’s archived PDF (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {DownloadOpsShopDocumentPdfKindEnum} kind 
         * @param {string} documentId Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOpsShopDocumentPdf(xOpsShopAccess: string, shopId: string, kind: DownloadOpsShopDocumentPdfKindEnum, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOpsShopDocumentPdf(xOpsShopAccess, shopId, kind, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.downloadOpsShopDocumentPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Re-enable an operator (audited)
         * @param {string} username 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableOperator(username: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableOperator(username, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.enableOperator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Writes a durable OperatorAuditLog row, then re-checks each order against fresh data with the gap predicate and mints it through the single invoice writer (next sequential number, Rechnungsdatum = processed_at). Customer email is off unless sendCustomerEmail is true. At most 25 orders per call. Raises one merchant notice naming the period the new invoices are dated in.
         * @summary Mint invoices for previewed orders (audited)
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {PeriodBackfillExecuteRequestDto} periodBackfillExecuteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeOpsPeriodBackfill(shopId: string, xOpsShopAccess: string, periodBackfillExecuteRequestDto: PeriodBackfillExecuteRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeriodBackfillExecuteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeOpsPeriodBackfill(shopId, xOpsShopAccess, periodBackfillExecuteRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.executeOpsPeriodBackfill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Calls Shopify appSubscriptionTrialExtend for the shop\'s ACTIVE subscription while it is still in trial, at most 30 days per action. Writes the audit row before Shopify is called. A Shopify refusal (userErrors) is returned with extended=false, not thrown.
         * @summary Extend a running trial (audited)
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {TrialExtensionRequestDto} trialExtensionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendOpsShopTrial(shopId: string, xOpsShopAccess: string, trialExtensionRequestDto: TrialExtensionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialExtensionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendOpsShopTrial(shopId, xOpsShopAccess, trialExtensionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.extendOpsShopTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read one operator audit entry including its payload
         * @param {string} id OperatorAuditLog id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorAuditEntry(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorAuditEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorAuditEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getOperatorAuditEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * EUR, accrual. Default range: the last 12 months including the running one; at most 36 months.
         * @summary Operations report: P&L, SaaS metrics, unit economics, plan, runway
         * @param {string} [from] First month, YYYY-MM.
         * @param {string} [to] Last month, YYYY-MM.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpsFinanceReport(from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsFinanceReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpsFinanceReport(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getOpsFinanceReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The snapshot the collector builds every 15 s. Poll at most every 15 s; it never changes faster.
         * @summary Infrastructure: nodes, Load Balancer, database connection budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpsInfrastructure(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsInfrastructureDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpsInfrastructure(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getOpsInfrastructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Partner API mirror status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpsPartnerSyncStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsPartnerStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpsPartnerSyncStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getOpsPartnerSyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Local subscription (both slots, cap, trial), trial-extension eligibility, TrialHistory, recent billing cycles, failed usage records, redeemed vouchers, subscription transition audit and earlier operator billing actions. DB only.
         * @summary Read a shop\'s billing detail
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpsShopBilling(shopId: string, xOpsShopAccess: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsBillingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpsShopBilling(shopId, xOpsShopAccess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getOpsShopBilling']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Settings summary and lock state (no secrets), every Steuerberater invite (never the token hash), every export schedule with its recipients and their confirmation state — distinguishing a double-opt-in confirmation from a recipient the Kanzlei’s finalise created CONFIRMED — and the latest DATEV EXTF export jobs.
         * @summary Read a shop\'s DATEV invite, export recipients and last exports
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpsShopDatev(shopId: string, xOpsShopAccess: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDatevOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpsShopDatev(shopId, xOpsShopAccess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getOpsShopDatev']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Identity, subscription, contract acceptance, setup, Shopify scope approval, open alerts and attention items, recent webhooks, documents, exports and tickets. Sections that cannot be read are null and named in `unavailable`.
         * @summary Read a shop file
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpsShopFile(shopId: string, xOpsShopAccess: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpsShopFile(shopId, xOpsShopAccess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getOpsShopFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * queued while the worker runs it, then completed (the server accepted it — check your inbox) or failed (with the classified reason).
         * @summary Poll an SMTP test mail
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} jobId From sendOpsShopSmtpTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpsShopSmtpTestStatus(xOpsShopAccess: string, shopId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsSmtpTestStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpsShopSmtpTestStatus(xOpsShopAccess, shopId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getOpsShopSmtpTestStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a shop’s document numbering state
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShopNumbering(shopId: string, xOpsShopAccess: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopNumberingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShopNumbering(shopId, xOpsShopAccess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.getShopNumbering']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change an operator password — returns a fresh bearer token
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerChangePasswordV1(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerChangePasswordV1(changePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerChangePasswordV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Discard all failed jobs in a queue (audited, reason required)
         * @param {string} name 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerDiscardAllV1(name: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueDiscardAllResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerDiscardAllV1(name, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerDiscardAllV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Discard (delete) a specific job (audited, reason required)
         * @param {string} name 
         * @param {string} id 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerDiscardJobV1(name: string, id: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueJobActionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerDiscardJobV1(name, id, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerDiscardJobV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all queue statistics and health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerGetAllQueuesV1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerGetAllQueuesV1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerGetAllQueuesV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get full job detail including stacktrace
         * @param {string} name 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerGetJobV1(name: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerGetJobV1(name, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerGetJobV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List jobs by state with pagination
         * @param {string} name 
         * @param {string} [shopId] Filter by shop ID or domain
         * @param {string} [search] Search by job name, ID, error, or data preview
         * @param {string} [limit] Items per page (max 100)
         * @param {string} [page] Page number (1-based)
         * @param {InternalAdminControllerGetJobsV1StateEnum} [state] Job state filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerGetJobsV1(name: string, shopId?: string, search?: string, limit?: string, page?: string, state?: InternalAdminControllerGetJobsV1StateEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerGetJobsV1(name, shopId, search, limit, page, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerGetJobsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get rolling 24h metrics history for charts
         * @param {string} [minutes] Number of minutes of history (1–1440, default 60)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerGetMetricsHistoryV1(minutes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerGetMetricsHistoryV1(minutes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerGetMetricsHistoryV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the persistent FailedJob table (survives BullMQ removeOnFail eviction). Unresolved-only by default. Operator-only.
         * @summary List durable terminally-failed jobs
         * @param {InternalAdminControllerListFailedJobsV1QueueNameEnum} [queueName] Filter by queue name.
         * @param {string} [shopId] Filter by shop ID (best-effort field; some jobs have no shop).
         * @param {boolean} [includeResolved] Whether to include already-resolved records. Defaults to false (unresolved only).
         * @param {number} [page] Page number (1-based).
         * @param {number} [limit] Items per page (max 100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerListFailedJobsV1(queueName?: InternalAdminControllerListFailedJobsV1QueueNameEnum, shopId?: string, includeResolved?: boolean, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FailedJobsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerListFailedJobsV1(queueName, shopId, includeResolved, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerListFailedJobsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin login — returns a signed bearer token
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerLoginV1(loginDto: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerLoginV1(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerLoginV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pause a queue (audited, reason required)
         * @param {string} name 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerPauseV1(name: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueuePauseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerPauseV1(name, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerPauseV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resolve (clear) a durable failed-job record (audited, reason required)
         * @param {string} id FailedJob record id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerResolveFailedJobV1(id: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolveFailedJobResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerResolveFailedJobV1(id, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerResolveFailedJobV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resume a paused queue (audited, reason required)
         * @param {string} name 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerResumeV1(name: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueuePauseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerResumeV1(name, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerResumeV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retry all failed jobs in a queue (audited, reason required)
         * @param {string} name 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerRetryAllV1(name: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueRetryAllResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerRetryAllV1(name, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerRetryAllV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retry a specific job (audited, reason required)
         * @param {string} name 
         * @param {string} id 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerRetryJobV1(name: string, id: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueJobActionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerRetryJobV1(name, id, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerRetryJobV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches the live subscription from Shopify Admin API and replays the webhook update handler to reconcile local DB. Operator-only (HMAC token from /internal-admin/auth/login).
         * @summary Force-sync subscription from Shopify
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAdminControllerSyncSubscriptionFromShopifyV1(shopId: string, xOpsShopAccess: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAdminControllerSyncSubscriptionFromShopifyV1(shopId, xOpsShopAccess, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.internalAdminControllerSyncSubscriptionFromShopifyV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Active snippets by default; includeArchived adds archived ones. A category returns the snippets for that ticket category plus those that fit any. Shipped defaults that are missing are inserted first; an operator-edited default is never overwritten.
         * @summary List canned responses
         * @param {boolean} [includeArchived] Include archived snippets (the management page). The picker leaves this off.
         * @param {ListCannedResponsesCategoryEnum} [category] Only snippets for this ticket category, plus those that fit any category (category null).
         * @param {string} [q] Case-insensitive search over title and both bodies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCannedResponses(includeArchived?: boolean, category?: ListCannedResponsesCategoryEnum, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CannedResponseListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCannedResponses(includeArchived, category, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listCannedResponses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List saved email signatures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmailSignatures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailSignatureListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmailSignatures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listEmailSignatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Filter by operator, action, shop domain and date. Payloads are not included — open one entry to read its payload (that read is itself audited).
         * @summary List operator audit entries
         * @param {string} [operator] 
         * @param {string} [action] 
         * @param {string} [shopDomain] Exact shop domain, or &#x60;*&#x60; for cross-shop actions.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOperatorAudit(operator?: string, action?: string, shopDomain?: string, from?: string, to?: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorAuditListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOperatorAudit(operator, action, shopDomain, from, to, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOperatorAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List operators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOperators(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOperators(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOperators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List plan figures of a year
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpsBudgets(year: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsBudgetListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpsBudgets(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOpsBudgets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List cash balances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpsCashBalances(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsCashBalanceListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpsCashBalances(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOpsCashBalances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List cost items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpsCostItems(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsCostItemListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpsCostItems(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOpsCostItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List stored USD→EUR month rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpsFxRates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsFxRateListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpsFxRates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOpsFxRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Newest first across invoices, credit notes and cancellation invoices, 25 per page. With q, the support document lookup (document number, order name or order id) — unpaged, capped, and `truncated` says so.
         * @summary List or search a shop’s documents
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} [q] A document number as the merchant quoted it (RE-26392, 26392), an order name (#1001) or an order id. Uses the support document lookup; paging does not apply to a search.
         * @param {OpsDocumentKind} [kind] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpsShopDocuments(xOpsShopAccess: string, shopId: string, q?: string, kind?: OpsDocumentKind, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDocumentListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpsShopDocuments(xOpsShopAccess, shopId, q, kind, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOpsShopDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Document and export mail only — `notLogged` names the mail that never creates a row. SENT means the relay accepted the message, not that it arrived; bounces are not recorded.
         * @summary Read a shop’s email delivery log
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} [recipient] Part of the recipient address (case-insensitive).
         * @param {OpsEmailFilterStatus} [status] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpsShopEmailLog(xOpsShopAccess: string, shopId: string, recipient?: string, status?: OpsEmailFilterStatus, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsEmailLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpsShopEmailLog(xOpsShopAccess, shopId, recipient, status, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOpsShopEmailLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Shop identity, subscription id and date only. onCurrentSubscription tells whether the discount is still on the shop’s subscription.
         * @summary List the shops that redeemed a voucher code
         * @param {string} id VoucherCode id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpsVoucherUsages(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsVoucherUsageListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpsVoucherUsages(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOpsVoucherUsages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Newest first, with the currentUsage counter AND the usage-row count (both can under-count). Fixed amounts are in billingCurrency (USD).
         * @summary List voucher codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpsVouchers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsVoucherListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpsVouchers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.listOpsVouchers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Writes an OperatorAuditLog row with the reason or the ticket, and returns a grant valid for two hours. Every read of the shop requires the grant in the X-Ops-Shop-Access header.
         * @summary Open a shop with a reason (audited)
         * @param {string} shopId Shop id or myshopify domain
         * @param {ShopAccessRequestDto} shopAccessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openOpsShopAccess(shopId: string, shopAccessRequestDto: ShopAccessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopAccessGrantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openOpsShopAccess(shopId, shopAccessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.openOpsShopAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the paid orders in the period that the daily reconciliation would call a gap (the SAME predicate), the orders it leaves alone grouped by reason, whether the scan was truncated, and the window actually scanned (clamped to Shopify’s 60-day read window and to the invoicing anchor). Returns a preview token that arms execute for 15 minutes.
         * @summary Preview a period backfill (dry run)
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {PeriodBackfillPreviewRequestDto} periodBackfillPreviewRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewOpsPeriodBackfill(shopId: string, xOpsShopAccess: string, periodBackfillPreviewRequestDto: PeriodBackfillPreviewRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeriodBackfillPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewOpsPeriodBackfill(shopId, xOpsShopAccess, periodBackfillPreviewRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.previewOpsPeriodBackfill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The next two free invoice numbers (Storno, then the new invoice) and the refusal the reissue would answer with. Reserves nothing; another document minted in between moves the numbers.
         * @summary Preview a reissue: the numbers it would draw and any refusal
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} documentId Invoice id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewOpsShopInvoiceReissue(xOpsShopAccess: string, shopId: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDocumentReissuePreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewOpsShopInvoiceReissue(xOpsShopAccess, shopId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.previewOpsShopInvoiceReissue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only for a document with NO stored PDF. An archived PDF is never re-rendered (§147 AO) — resend it instead.
         * @summary Regenerate a missing PDF (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {RegenerateOpsShopDocumentKindEnum} kind 
         * @param {string} documentId Document id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateOpsShopDocument(xOpsShopAccess: string, shopId: string, kind: RegenerateOpsShopDocumentKindEnum, documentId: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDocumentActionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateOpsShopDocument(xOpsShopAccess, shopId, kind, documentId, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.regenerateOpsShopDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Re-reads the order from Shopify, writes a Stornorechnung for the ACTIVE immutable invoice and a new invoice through the normal correction pipeline, in one transaction and the gapless sequence. Works for a document that was never emailed (CREATED with an archived PDF). An optional customer VAT ID is format-checked, stored on the customer and printed on the new invoice. The Shopify order is never changed. Both documents then go through the normal PDF and email jobs.
         * @summary Reissue an invoice: Storno plus a new invoice from the current order (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {string} documentId Invoice id
         * @param {OpsDocumentReissueDto} opsDocumentReissueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reissueOpsShopInvoice(xOpsShopAccess: string, shopId: string, documentId: string, opsDocumentReissueDto: OpsDocumentReissueDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDocumentReissueResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reissueOpsShopInvoice(xOpsShopAccess, shopId, documentId, opsDocumentReissueDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.reissueOpsShopInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Same path as the merchant\'s resend: mints a NEW token, so the Kanzlei\'s previous link stops working even if this send fails. Only the shop\'s newest PENDING invite is resendable. A successful send closes DATEV_INVITE_UNDELIVERED by itself. Rate-limited per shop.
         * @summary Resend the pending Steuerberater invite (audited)
         * @param {string} shopId Shop id
         * @param {string} inviteId DatevAccountantInvite id
         * @param {string} xOpsShopAccess 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendOpsDatevInvite(shopId: string, inviteId: string, xOpsShopAccess: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDatevInviteResendResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendOpsDatevInvite(shopId, inviteId, xOpsShopAccess, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.resendOpsDatevInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Same path as the merchant\'s resend: rotates the confirmation token, so the recipient\'s earlier link stops working. PENDING and EXPIRED recipients only — a CONFIRMED one would be reset to pending, a REJECTED one declined. Rate-limited per shop.
         * @summary Resend an export recipient\'s confirmation email (audited)
         * @param {string} shopId Shop id
         * @param {string} recipientId ScheduleRecipient id
         * @param {string} xOpsShopAccess 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendOpsRecipientConfirmation(shopId: string, recipientId: string, xOpsShopAccess: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsRecipientResendResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendOpsRecipientConfirmation(shopId, recipientId, xOpsShopAccess, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.resendOpsRecipientConfirmation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Queues the merchant’s own resend of the ARCHIVED PDF. recipientOverride needs the ticketId of a support ticket of this shop. Refused for a document the shop is holding for its own first send (automatic sending off). A failed send still raises the merchant’s own failure alert.
         * @summary Resend a document email (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {ResendOpsShopDocumentKindEnum} kind 
         * @param {string} documentId Document id
         * @param {OpsDocumentResendDto} opsDocumentResendDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendOpsShopDocument(xOpsShopAccess: string, shopId: string, kind: ResendOpsShopDocumentKindEnum, documentId: string, opsDocumentResendDto: OpsDocumentResendDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsDocumentActionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendOpsShopDocument(xOpsShopAccess, shopId, kind, documentId, opsDocumentResendDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.resendOpsShopDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset an operator password (audited) — returns a one-time password
         * @param {string} username 
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetOperatorPassword(username: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorOneTimePasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetOperatorPassword(username, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.resetOperatorPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Restore an archived canned response (audited)
         * @param {string} id SupportCannedResponse id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreCannedResponse(id: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CannedResponseWriteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreCannedResponse(id, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.restoreCannedResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns identity only (domain, name, which field matched). Opening a shop needs a reason — see openOpsShopAccess.
         * @summary Find shops by domain, name or email
         * @param {string} q Part of a shop domain, shop name or legal name, or an email the shop uses (support, SMTP sender, a staff login).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOpsShops(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOpsShops(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.searchOpsShops']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The worker sends an export-shaped test through the merchant’s SMTP to YOUR operator address — never to anyone else, and without the connection probe that writes an error onto the merchant’s settings. Not applicable on our fallback relay or without a complete SMTP configuration.
         * @summary Send an SMTP test mail to yourself (audited)
         * @param {string} xOpsShopAccess 
         * @param {string} shopId Shop id
         * @param {OperatorReasonDto} operatorReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOpsShopSmtpTest(xOpsShopAccess: string, shopId: string, operatorReasonDto: OperatorReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsSmtpTestResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOpsShopSmtpTest(xOpsShopAccess, shopId, operatorReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.sendOpsShopSmtpTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A null amount removes the figure. Returns the whole year.
         * @summary Set or clear one plan figure (audited)
         * @param {OpsBudgetInputDto} opsBudgetInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOpsBudget(opsBudgetInputDto: OpsBudgetInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsBudgetListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOpsBudget(opsBudgetInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.setOpsBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stored as MANUAL; an ECB fetch never replaces it.
         * @summary Override a month’s USD→EUR rate (audited)
         * @param {string} month YYYY-MM
         * @param {OpsFxRateInputDto} opsFxRateInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOpsFxRate(month: string, opsFxRateInputDto: OpsFxRateInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsFxRateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOpsFxRate(month, opsFxRateInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.setOpsFxRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Runs in the background; poll the status. Idempotent — a re-pull changes nothing.
         * @summary Pull the Partner API now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startOpsPartnerSync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsPartnerSyncStartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startOpsPartnerSync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.startOpsPartnerSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
         * @summary Edit a canned response (audited, optimistic concurrency)
         * @param {string} id SupportCannedResponse id
         * @param {UpdateCannedResponseDto} updateCannedResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCannedResponse(id: string, updateCannedResponseDto: UpdateCannedResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CannedResponseWriteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCannedResponse(id, updateCannedResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.updateCannedResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the whole content. expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
         * @summary Save an edited email signature (audited, optimistic concurrency)
         * @param {string} id EmailSignature id
         * @param {UpdateEmailSignatureDto} updateEmailSignatureDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailSignature(id: string, updateEmailSignatureDto: UpdateEmailSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailSignatureWriteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailSignature(id, updateEmailSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.updateEmailSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an operator profile (audited)
         * @param {string} username 
         * @param {UpdateOperatorDto} updateOperatorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperator(username: string, updateOperatorDto: UpdateOperatorDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperator(username, updateOperatorDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.updateOperator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restates every month the item ran in. To record a price change, end the item and start a new one.
         * @summary Edit a cost item (audited)
         * @param {string} id FinanceCostItem id
         * @param {OpsCostItemInputDto} opsCostItemInputDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOpsCostItem(id: string, opsCostItemInputDto: OpsCostItemInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpsCostItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOpsCostItem(id, opsCostItemInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.updateOpsCostItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change a shop’s onboarding-frozen document numbering
         * @param {string} shopId Shop id
         * @param {string} xOpsShopAccess 
         * @param {UpdateShopNumberingDto} updateShopNumberingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShopNumbering(shopId: string, xOpsShopAccess: string, updateShopNumberingDto: UpdateShopNumberingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateShopNumberingResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShopNumbering(shopId, xOpsShopAccess, updateShopNumberingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalAdminApi.updateShopNumbering']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalAdminApi - factory interface
 * @export
 */
export const InternalAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Archive a canned response (audited)
         * @param {InternalAdminApiArchiveCannedResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCannedResponse(requestParameters: InternalAdminApiArchiveCannedResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseWriteResultDto> {
            return localVarFp.archiveCannedResponse(requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the order from Shopify, runs the standard invoice creation pipeline (same calculation audit, same PDF generation), consumes the supplied invoice number, and writes an OperatorAuditLog row. Operator-only.
         * @summary Backfill an invoice for an order whose webhook was lost
         * @param {InternalAdminApiBackfillInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfillInvoice(requestParameters: InternalAdminApiBackfillInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BackfillInvoiceResponseDto> {
            return localVarFp.backfillInvoice(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.backfillInvoiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates one in-app Alert per targeted shop, rendered in that shop’s Shop.locale from operator-supplied per-locale copy. Deduped by `broadcast:<broadcastKey>`; supports a dry run. Operator-only.
         * @summary Broadcast a custom system alert to merchants, in each shop’s language
         * @param {InternalAdminApiBroadcastAlertRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        broadcastAlert(requestParameters: InternalAdminApiBroadcastAlertRequest, options?: RawAxiosRequestConfig): AxiosPromise<BroadcastAlertResponseDto> {
            return localVarFp.broadcastAlert(requestParameters.broadcastAlertDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a month’s rate (audited)
         * @param {InternalAdminApiClearOpsFxRateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOpsFxRate(requestParameters: InternalAdminApiClearOpsFxRateRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDeleteResultDto> {
            return localVarFp.clearOpsFxRate(requestParameters.month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a canned response (audited)
         * @param {InternalAdminApiCreateCannedResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCannedResponse(requestParameters: InternalAdminApiCreateCannedResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseWriteResultDto> {
            return localVarFp.createCannedResponse(requestParameters.createCannedResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save a new email signature (audited)
         * @param {InternalAdminApiCreateEmailSignatureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailSignature(requestParameters: InternalAdminApiCreateEmailSignatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailSignatureWriteResultDto> {
            return localVarFp.createEmailSignature(requestParameters.createEmailSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an operator (audited) — returns a one-time password
         * @param {InternalAdminApiCreateOperatorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperator(requestParameters: InternalAdminApiCreateOperatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorOneTimePasswordDto> {
            return localVarFp.createOperator(requestParameters.createOperatorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record a cash balance (audited)
         * @param {InternalAdminApiCreateOpsCashBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpsCashBalance(requestParameters: InternalAdminApiCreateOpsCashBalanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsCashBalanceDto> {
            return localVarFp.createOpsCashBalance(requestParameters.opsCashBalanceInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a cost item (audited)
         * @param {InternalAdminApiCreateOpsCostItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpsCostItem(requestParameters: InternalAdminApiCreateOpsCostItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsCostItemDto> {
            return localVarFp.createOpsCostItem(requestParameters.opsCostItemInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies to subscriptions created AFTER this point only — the discount rides appSubscriptionCreate.
         * @summary Create a voucher code (audited)
         * @param {InternalAdminApiCreateOpsVoucherRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpsVoucher(requestParameters: InternalAdminApiCreateOpsVoucherRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsVoucherWriteResultDto> {
            return localVarFp.createOpsVoucher(requestParameters.createVoucherRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Stops new redemptions. Subscriptions that already carry the discount keep it. The code is never deleted: its usage rows would cascade away.
         * @summary Deactivate a voucher code (audited)
         * @param {InternalAdminApiDeactivateOpsVoucherRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateOpsVoucher(requestParameters: InternalAdminApiDeactivateOpsVoucherRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsVoucherWriteResultDto> {
            return localVarFp.deactivateOpsVoucher(requestParameters.id, requestParameters.deactivateVoucherRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a saved email signature (audited)
         * @param {InternalAdminApiDeleteEmailSignatureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailSignature(requestParameters: InternalAdminApiDeleteEmailSignatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailSignatureDeleteResultDto> {
            return localVarFp.deleteEmailSignature(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a cash balance (audited)
         * @param {InternalAdminApiDeleteOpsCashBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpsCashBalance(requestParameters: InternalAdminApiDeleteOpsCashBalanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDeleteResultDto> {
            return localVarFp.deleteOpsCashBalance(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * For mistakes. A cancelled cost gets an end month instead, so past months stay.
         * @summary Delete a cost item (audited)
         * @param {InternalAdminApiDeleteOpsCostItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpsCostItem(requestParameters: InternalAdminApiDeleteOpsCostItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDeleteResultDto> {
            return localVarFp.deleteOpsCostItem(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Traces the order through webhook events, attention items, durable failed jobs and its documents, reads the shop state and the order from Shopify, and returns one verdict token plus exactly one next action for the invoice family and for the refund/cancellation family. Writes an OperatorAuditLog row (order.diagnosis.view).
         * @summary Diagnose why an order has or lacks its invoice, credit note or Storno
         * @param {InternalAdminApiDiagnoseOpsOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnoseOpsOrder(requestParameters: InternalAdminApiDiagnoseOpsOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDiagnosisDto> {
            return localVarFp.diagnoseOpsOrder(requestParameters.shopId, requestParameters.order, requestParameters.xOpsShopAccess, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable an operator (audited)
         * @param {InternalAdminApiDisableOperatorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableOperator(requestParameters: InternalAdminApiDisableOperatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorDto> {
            return localVarFp.disableOperator(requestParameters.username, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The stored bytes, decrypted, exactly as archived. Writes document.pdf.download to the operator audit log first.
         * @summary Download a document’s archived PDF (audited)
         * @param {InternalAdminApiDownloadOpsShopDocumentPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOpsShopDocumentPdf(requestParameters: InternalAdminApiDownloadOpsShopDocumentPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadOpsShopDocumentPdf(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.kind, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-enable an operator (audited)
         * @param {InternalAdminApiEnableOperatorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableOperator(requestParameters: InternalAdminApiEnableOperatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorDto> {
            return localVarFp.enableOperator(requestParameters.username, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Writes a durable OperatorAuditLog row, then re-checks each order against fresh data with the gap predicate and mints it through the single invoice writer (next sequential number, Rechnungsdatum = processed_at). Customer email is off unless sendCustomerEmail is true. At most 25 orders per call. Raises one merchant notice naming the period the new invoices are dated in.
         * @summary Mint invoices for previewed orders (audited)
         * @param {InternalAdminApiExecuteOpsPeriodBackfillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeOpsPeriodBackfill(requestParameters: InternalAdminApiExecuteOpsPeriodBackfillRequest, options?: RawAxiosRequestConfig): AxiosPromise<PeriodBackfillExecuteResultDto> {
            return localVarFp.executeOpsPeriodBackfill(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.periodBackfillExecuteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Calls Shopify appSubscriptionTrialExtend for the shop\'s ACTIVE subscription while it is still in trial, at most 30 days per action. Writes the audit row before Shopify is called. A Shopify refusal (userErrors) is returned with extended=false, not thrown.
         * @summary Extend a running trial (audited)
         * @param {InternalAdminApiExtendOpsShopTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendOpsShopTrial(requestParameters: InternalAdminApiExtendOpsShopTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialExtensionResultDto> {
            return localVarFp.extendOpsShopTrial(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.trialExtensionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read one operator audit entry including its payload
         * @param {InternalAdminApiGetOperatorAuditEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorAuditEntry(requestParameters: InternalAdminApiGetOperatorAuditEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorAuditEntryDto> {
            return localVarFp.getOperatorAuditEntry(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * EUR, accrual. Default range: the last 12 months including the running one; at most 36 months.
         * @summary Operations report: P&L, SaaS metrics, unit economics, plan, runway
         * @param {InternalAdminApiGetOpsFinanceReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsFinanceReport(requestParameters: InternalAdminApiGetOpsFinanceReportRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OpsFinanceReportDto> {
            return localVarFp.getOpsFinanceReport(requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         * The snapshot the collector builds every 15 s. Poll at most every 15 s; it never changes faster.
         * @summary Infrastructure: nodes, Load Balancer, database connection budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsInfrastructure(options?: RawAxiosRequestConfig): AxiosPromise<OpsInfrastructureDto> {
            return localVarFp.getOpsInfrastructure(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Partner API mirror status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsPartnerSyncStatus(options?: RawAxiosRequestConfig): AxiosPromise<OpsPartnerStatusDto> {
            return localVarFp.getOpsPartnerSyncStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Local subscription (both slots, cap, trial), trial-extension eligibility, TrialHistory, recent billing cycles, failed usage records, redeemed vouchers, subscription transition audit and earlier operator billing actions. DB only.
         * @summary Read a shop\'s billing detail
         * @param {InternalAdminApiGetOpsShopBillingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsShopBilling(requestParameters: InternalAdminApiGetOpsShopBillingRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsBillingDto> {
            return localVarFp.getOpsShopBilling(requestParameters.shopId, requestParameters.xOpsShopAccess, options).then((request) => request(axios, basePath));
        },
        /**
         * Settings summary and lock state (no secrets), every Steuerberater invite (never the token hash), every export schedule with its recipients and their confirmation state — distinguishing a double-opt-in confirmation from a recipient the Kanzlei’s finalise created CONFIRMED — and the latest DATEV EXTF export jobs.
         * @summary Read a shop\'s DATEV invite, export recipients and last exports
         * @param {InternalAdminApiGetOpsShopDatevRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsShopDatev(requestParameters: InternalAdminApiGetOpsShopDatevRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDatevOverviewDto> {
            return localVarFp.getOpsShopDatev(requestParameters.shopId, requestParameters.xOpsShopAccess, options).then((request) => request(axios, basePath));
        },
        /**
         * Identity, subscription, contract acceptance, setup, Shopify scope approval, open alerts and attention items, recent webhooks, documents, exports and tickets. Sections that cannot be read are null and named in `unavailable`.
         * @summary Read a shop file
         * @param {InternalAdminApiGetOpsShopFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsShopFile(requestParameters: InternalAdminApiGetOpsShopFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopFileDto> {
            return localVarFp.getOpsShopFile(requestParameters.shopId, requestParameters.xOpsShopAccess, options).then((request) => request(axios, basePath));
        },
        /**
         * queued while the worker runs it, then completed (the server accepted it — check your inbox) or failed (with the classified reason).
         * @summary Poll an SMTP test mail
         * @param {InternalAdminApiGetOpsShopSmtpTestStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpsShopSmtpTestStatus(requestParameters: InternalAdminApiGetOpsShopSmtpTestStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsSmtpTestStatusDto> {
            return localVarFp.getOpsShopSmtpTestStatus(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a shop’s document numbering state
         * @param {InternalAdminApiGetShopNumberingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopNumbering(requestParameters: InternalAdminApiGetShopNumberingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopNumberingDto> {
            return localVarFp.getShopNumbering(requestParameters.shopId, requestParameters.xOpsShopAccess, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change an operator password — returns a fresh bearer token
         * @param {InternalAdminApiInternalAdminControllerChangePasswordV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerChangePasswordV1(requestParameters: InternalAdminApiInternalAdminControllerChangePasswordV1Request, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.internalAdminControllerChangePasswordV1(requestParameters.changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Discard all failed jobs in a queue (audited, reason required)
         * @param {InternalAdminApiInternalAdminControllerDiscardAllV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerDiscardAllV1(requestParameters: InternalAdminApiInternalAdminControllerDiscardAllV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueueDiscardAllResponseDto> {
            return localVarFp.internalAdminControllerDiscardAllV1(requestParameters.name, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Discard (delete) a specific job (audited, reason required)
         * @param {InternalAdminApiInternalAdminControllerDiscardJobV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerDiscardJobV1(requestParameters: InternalAdminApiInternalAdminControllerDiscardJobV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueueJobActionResponseDto> {
            return localVarFp.internalAdminControllerDiscardJobV1(requestParameters.name, requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all queue statistics and health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerGetAllQueuesV1(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.internalAdminControllerGetAllQueuesV1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get full job detail including stacktrace
         * @param {InternalAdminApiInternalAdminControllerGetJobV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerGetJobV1(requestParameters: InternalAdminApiInternalAdminControllerGetJobV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.internalAdminControllerGetJobV1(requestParameters.name, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List jobs by state with pagination
         * @param {InternalAdminApiInternalAdminControllerGetJobsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerGetJobsV1(requestParameters: InternalAdminApiInternalAdminControllerGetJobsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.internalAdminControllerGetJobsV1(requestParameters.name, requestParameters.shopId, requestParameters.search, requestParameters.limit, requestParameters.page, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get rolling 24h metrics history for charts
         * @param {InternalAdminApiInternalAdminControllerGetMetricsHistoryV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerGetMetricsHistoryV1(requestParameters: InternalAdminApiInternalAdminControllerGetMetricsHistoryV1Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.internalAdminControllerGetMetricsHistoryV1(requestParameters.minutes, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the persistent FailedJob table (survives BullMQ removeOnFail eviction). Unresolved-only by default. Operator-only.
         * @summary List durable terminally-failed jobs
         * @param {InternalAdminApiInternalAdminControllerListFailedJobsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerListFailedJobsV1(requestParameters: InternalAdminApiInternalAdminControllerListFailedJobsV1Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<FailedJobsListDto> {
            return localVarFp.internalAdminControllerListFailedJobsV1(requestParameters.queueName, requestParameters.shopId, requestParameters.includeResolved, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin login — returns a signed bearer token
         * @param {InternalAdminApiInternalAdminControllerLoginV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerLoginV1(requestParameters: InternalAdminApiInternalAdminControllerLoginV1Request, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.internalAdminControllerLoginV1(requestParameters.loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pause a queue (audited, reason required)
         * @param {InternalAdminApiInternalAdminControllerPauseV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerPauseV1(requestParameters: InternalAdminApiInternalAdminControllerPauseV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueuePauseResponseDto> {
            return localVarFp.internalAdminControllerPauseV1(requestParameters.name, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve (clear) a durable failed-job record (audited, reason required)
         * @param {InternalAdminApiInternalAdminControllerResolveFailedJobV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerResolveFailedJobV1(requestParameters: InternalAdminApiInternalAdminControllerResolveFailedJobV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ResolveFailedJobResponseDto> {
            return localVarFp.internalAdminControllerResolveFailedJobV1(requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resume a paused queue (audited, reason required)
         * @param {InternalAdminApiInternalAdminControllerResumeV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerResumeV1(requestParameters: InternalAdminApiInternalAdminControllerResumeV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueuePauseResponseDto> {
            return localVarFp.internalAdminControllerResumeV1(requestParameters.name, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry all failed jobs in a queue (audited, reason required)
         * @param {InternalAdminApiInternalAdminControllerRetryAllV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerRetryAllV1(requestParameters: InternalAdminApiInternalAdminControllerRetryAllV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueueRetryAllResponseDto> {
            return localVarFp.internalAdminControllerRetryAllV1(requestParameters.name, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry a specific job (audited, reason required)
         * @param {InternalAdminApiInternalAdminControllerRetryJobV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerRetryJobV1(requestParameters: InternalAdminApiInternalAdminControllerRetryJobV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueueJobActionResponseDto> {
            return localVarFp.internalAdminControllerRetryJobV1(requestParameters.name, requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the live subscription from Shopify Admin API and replays the webhook update handler to reconcile local DB. Operator-only (HMAC token from /internal-admin/auth/login).
         * @summary Force-sync subscription from Shopify
         * @param {InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAdminControllerSyncSubscriptionFromShopifyV1(requestParameters: InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.internalAdminControllerSyncSubscriptionFromShopifyV1(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Active snippets by default; includeArchived adds archived ones. A category returns the snippets for that ticket category plus those that fit any. Shipped defaults that are missing are inserted first; an operator-edited default is never overwritten.
         * @summary List canned responses
         * @param {InternalAdminApiListCannedResponsesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCannedResponses(requestParameters: InternalAdminApiListCannedResponsesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseListDto> {
            return localVarFp.listCannedResponses(requestParameters.includeArchived, requestParameters.category, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List saved email signatures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailSignatures(options?: RawAxiosRequestConfig): AxiosPromise<EmailSignatureListDto> {
            return localVarFp.listEmailSignatures(options).then((request) => request(axios, basePath));
        },
        /**
         * Filter by operator, action, shop domain and date. Payloads are not included — open one entry to read its payload (that read is itself audited).
         * @summary List operator audit entries
         * @param {InternalAdminApiListOperatorAuditRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperatorAudit(requestParameters: InternalAdminApiListOperatorAuditRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OperatorAuditListDto> {
            return localVarFp.listOperatorAudit(requestParameters.operator, requestParameters.action, requestParameters.shopDomain, requestParameters.from, requestParameters.to, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List operators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperators(options?: RawAxiosRequestConfig): AxiosPromise<OperatorListDto> {
            return localVarFp.listOperators(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List plan figures of a year
         * @param {InternalAdminApiListOpsBudgetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsBudgets(requestParameters: InternalAdminApiListOpsBudgetsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsBudgetListDto> {
            return localVarFp.listOpsBudgets(requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List cash balances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsCashBalances(options?: RawAxiosRequestConfig): AxiosPromise<OpsCashBalanceListDto> {
            return localVarFp.listOpsCashBalances(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List cost items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsCostItems(options?: RawAxiosRequestConfig): AxiosPromise<OpsCostItemListDto> {
            return localVarFp.listOpsCostItems(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List stored USD→EUR month rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsFxRates(options?: RawAxiosRequestConfig): AxiosPromise<OpsFxRateListDto> {
            return localVarFp.listOpsFxRates(options).then((request) => request(axios, basePath));
        },
        /**
         * Newest first across invoices, credit notes and cancellation invoices, 25 per page. With q, the support document lookup (document number, order name or order id) — unpaged, capped, and `truncated` says so.
         * @summary List or search a shop’s documents
         * @param {InternalAdminApiListOpsShopDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsShopDocuments(requestParameters: InternalAdminApiListOpsShopDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentListDto> {
            return localVarFp.listOpsShopDocuments(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.q, requestParameters.kind, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Document and export mail only — `notLogged` names the mail that never creates a row. SENT means the relay accepted the message, not that it arrived; bounces are not recorded.
         * @summary Read a shop’s email delivery log
         * @param {InternalAdminApiListOpsShopEmailLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsShopEmailLog(requestParameters: InternalAdminApiListOpsShopEmailLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsEmailLogDto> {
            return localVarFp.listOpsShopEmailLog(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.recipient, requestParameters.status, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Shop identity, subscription id and date only. onCurrentSubscription tells whether the discount is still on the shop’s subscription.
         * @summary List the shops that redeemed a voucher code
         * @param {InternalAdminApiListOpsVoucherUsagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsVoucherUsages(requestParameters: InternalAdminApiListOpsVoucherUsagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsVoucherUsageListDto> {
            return localVarFp.listOpsVoucherUsages(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Newest first, with the currentUsage counter AND the usage-row count (both can under-count). Fixed amounts are in billingCurrency (USD).
         * @summary List voucher codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpsVouchers(options?: RawAxiosRequestConfig): AxiosPromise<OpsVoucherListDto> {
            return localVarFp.listOpsVouchers(options).then((request) => request(axios, basePath));
        },
        /**
         * Writes an OperatorAuditLog row with the reason or the ticket, and returns a grant valid for two hours. Every read of the shop requires the grant in the X-Ops-Shop-Access header.
         * @summary Open a shop with a reason (audited)
         * @param {InternalAdminApiOpenOpsShopAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openOpsShopAccess(requestParameters: InternalAdminApiOpenOpsShopAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopAccessGrantDto> {
            return localVarFp.openOpsShopAccess(requestParameters.shopId, requestParameters.shopAccessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the paid orders in the period that the daily reconciliation would call a gap (the SAME predicate), the orders it leaves alone grouped by reason, whether the scan was truncated, and the window actually scanned (clamped to Shopify’s 60-day read window and to the invoicing anchor). Returns a preview token that arms execute for 15 minutes.
         * @summary Preview a period backfill (dry run)
         * @param {InternalAdminApiPreviewOpsPeriodBackfillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOpsPeriodBackfill(requestParameters: InternalAdminApiPreviewOpsPeriodBackfillRequest, options?: RawAxiosRequestConfig): AxiosPromise<PeriodBackfillPreviewDto> {
            return localVarFp.previewOpsPeriodBackfill(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.periodBackfillPreviewRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The next two free invoice numbers (Storno, then the new invoice) and the refusal the reissue would answer with. Reserves nothing; another document minted in between moves the numbers.
         * @summary Preview a reissue: the numbers it would draw and any refusal
         * @param {InternalAdminApiPreviewOpsShopInvoiceReissueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOpsShopInvoiceReissue(requestParameters: InternalAdminApiPreviewOpsShopInvoiceReissueRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentReissuePreviewDto> {
            return localVarFp.previewOpsShopInvoiceReissue(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Only for a document with NO stored PDF. An archived PDF is never re-rendered (§147 AO) — resend it instead.
         * @summary Regenerate a missing PDF (audited)
         * @param {InternalAdminApiRegenerateOpsShopDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateOpsShopDocument(requestParameters: InternalAdminApiRegenerateOpsShopDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentActionResultDto> {
            return localVarFp.regenerateOpsShopDocument(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.kind, requestParameters.documentId, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Re-reads the order from Shopify, writes a Stornorechnung for the ACTIVE immutable invoice and a new invoice through the normal correction pipeline, in one transaction and the gapless sequence. Works for a document that was never emailed (CREATED with an archived PDF). An optional customer VAT ID is format-checked, stored on the customer and printed on the new invoice. The Shopify order is never changed. Both documents then go through the normal PDF and email jobs.
         * @summary Reissue an invoice: Storno plus a new invoice from the current order (audited)
         * @param {InternalAdminApiReissueOpsShopInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueOpsShopInvoice(requestParameters: InternalAdminApiReissueOpsShopInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentReissueResultDto> {
            return localVarFp.reissueOpsShopInvoice(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.documentId, requestParameters.opsDocumentReissueDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Same path as the merchant\'s resend: mints a NEW token, so the Kanzlei\'s previous link stops working even if this send fails. Only the shop\'s newest PENDING invite is resendable. A successful send closes DATEV_INVITE_UNDELIVERED by itself. Rate-limited per shop.
         * @summary Resend the pending Steuerberater invite (audited)
         * @param {InternalAdminApiResendOpsDatevInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOpsDatevInvite(requestParameters: InternalAdminApiResendOpsDatevInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDatevInviteResendResultDto> {
            return localVarFp.resendOpsDatevInvite(requestParameters.shopId, requestParameters.inviteId, requestParameters.xOpsShopAccess, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Same path as the merchant\'s resend: rotates the confirmation token, so the recipient\'s earlier link stops working. PENDING and EXPIRED recipients only — a CONFIRMED one would be reset to pending, a REJECTED one declined. Rate-limited per shop.
         * @summary Resend an export recipient\'s confirmation email (audited)
         * @param {InternalAdminApiResendOpsRecipientConfirmationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOpsRecipientConfirmation(requestParameters: InternalAdminApiResendOpsRecipientConfirmationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsRecipientResendResultDto> {
            return localVarFp.resendOpsRecipientConfirmation(requestParameters.shopId, requestParameters.recipientId, requestParameters.xOpsShopAccess, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Queues the merchant’s own resend of the ARCHIVED PDF. recipientOverride needs the ticketId of a support ticket of this shop. Refused for a document the shop is holding for its own first send (automatic sending off). A failed send still raises the merchant’s own failure alert.
         * @summary Resend a document email (audited)
         * @param {InternalAdminApiResendOpsShopDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOpsShopDocument(requestParameters: InternalAdminApiResendOpsShopDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentActionResultDto> {
            return localVarFp.resendOpsShopDocument(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.kind, requestParameters.documentId, requestParameters.opsDocumentResendDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset an operator password (audited) — returns a one-time password
         * @param {InternalAdminApiResetOperatorPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOperatorPassword(requestParameters: InternalAdminApiResetOperatorPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorOneTimePasswordDto> {
            return localVarFp.resetOperatorPassword(requestParameters.username, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restore an archived canned response (audited)
         * @param {InternalAdminApiRestoreCannedResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreCannedResponse(requestParameters: InternalAdminApiRestoreCannedResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseWriteResultDto> {
            return localVarFp.restoreCannedResponse(requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns identity only (domain, name, which field matched). Opening a shop needs a reason — see openOpsShopAccess.
         * @summary Find shops by domain, name or email
         * @param {InternalAdminApiSearchOpsShopsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOpsShops(requestParameters: InternalAdminApiSearchOpsShopsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopSearchResultDto> {
            return localVarFp.searchOpsShops(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * The worker sends an export-shaped test through the merchant’s SMTP to YOUR operator address — never to anyone else, and without the connection probe that writes an error onto the merchant’s settings. Not applicable on our fallback relay or without a complete SMTP configuration.
         * @summary Send an SMTP test mail to yourself (audited)
         * @param {InternalAdminApiSendOpsShopSmtpTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOpsShopSmtpTest(requestParameters: InternalAdminApiSendOpsShopSmtpTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsSmtpTestResultDto> {
            return localVarFp.sendOpsShopSmtpTest(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.operatorReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * A null amount removes the figure. Returns the whole year.
         * @summary Set or clear one plan figure (audited)
         * @param {InternalAdminApiSetOpsBudgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpsBudget(requestParameters: InternalAdminApiSetOpsBudgetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsBudgetListDto> {
            return localVarFp.setOpsBudget(requestParameters.opsBudgetInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Stored as MANUAL; an ECB fetch never replaces it.
         * @summary Override a month’s USD→EUR rate (audited)
         * @param {InternalAdminApiSetOpsFxRateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpsFxRate(requestParameters: InternalAdminApiSetOpsFxRateRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsFxRateDto> {
            return localVarFp.setOpsFxRate(requestParameters.month, requestParameters.opsFxRateInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Runs in the background; poll the status. Idempotent — a re-pull changes nothing.
         * @summary Pull the Partner API now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOpsPartnerSync(options?: RawAxiosRequestConfig): AxiosPromise<OpsPartnerSyncStartDto> {
            return localVarFp.startOpsPartnerSync(options).then((request) => request(axios, basePath));
        },
        /**
         * expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
         * @summary Edit a canned response (audited, optimistic concurrency)
         * @param {InternalAdminApiUpdateCannedResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCannedResponse(requestParameters: InternalAdminApiUpdateCannedResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseWriteResultDto> {
            return localVarFp.updateCannedResponse(requestParameters.id, requestParameters.updateCannedResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the whole content. expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
         * @summary Save an edited email signature (audited, optimistic concurrency)
         * @param {InternalAdminApiUpdateEmailSignatureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSignature(requestParameters: InternalAdminApiUpdateEmailSignatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailSignatureWriteResultDto> {
            return localVarFp.updateEmailSignature(requestParameters.id, requestParameters.updateEmailSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an operator profile (audited)
         * @param {InternalAdminApiUpdateOperatorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperator(requestParameters: InternalAdminApiUpdateOperatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorDto> {
            return localVarFp.updateOperator(requestParameters.username, requestParameters.updateOperatorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Restates every month the item ran in. To record a price change, end the item and start a new one.
         * @summary Edit a cost item (audited)
         * @param {InternalAdminApiUpdateOpsCostItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOpsCostItem(requestParameters: InternalAdminApiUpdateOpsCostItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsCostItemDto> {
            return localVarFp.updateOpsCostItem(requestParameters.id, requestParameters.opsCostItemInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change a shop’s onboarding-frozen document numbering
         * @param {InternalAdminApiUpdateShopNumberingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShopNumbering(requestParameters: InternalAdminApiUpdateShopNumberingRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateShopNumberingResponseDto> {
            return localVarFp.updateShopNumbering(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.updateShopNumberingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InternalAdminApi - interface
 * @export
 * @interface InternalAdminApi
 */
export interface InternalAdminApiInterface {
    /**
     * 
     * @summary Archive a canned response (audited)
     * @param {InternalAdminApiArchiveCannedResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    archiveCannedResponse(requestParameters: InternalAdminApiArchiveCannedResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseWriteResultDto>;

    /**
     * Fetches the order from Shopify, runs the standard invoice creation pipeline (same calculation audit, same PDF generation), consumes the supplied invoice number, and writes an OperatorAuditLog row. Operator-only.
     * @summary Backfill an invoice for an order whose webhook was lost
     * @param {InternalAdminApiBackfillInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    backfillInvoice(requestParameters: InternalAdminApiBackfillInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BackfillInvoiceResponseDto>;

    /**
     * Creates one in-app Alert per targeted shop, rendered in that shop’s Shop.locale from operator-supplied per-locale copy. Deduped by `broadcast:<broadcastKey>`; supports a dry run. Operator-only.
     * @summary Broadcast a custom system alert to merchants, in each shop’s language
     * @param {InternalAdminApiBroadcastAlertRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    broadcastAlert(requestParameters: InternalAdminApiBroadcastAlertRequest, options?: RawAxiosRequestConfig): AxiosPromise<BroadcastAlertResponseDto>;

    /**
     * 
     * @summary Remove a month’s rate (audited)
     * @param {InternalAdminApiClearOpsFxRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    clearOpsFxRate(requestParameters: InternalAdminApiClearOpsFxRateRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDeleteResultDto>;

    /**
     * 
     * @summary Create a canned response (audited)
     * @param {InternalAdminApiCreateCannedResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    createCannedResponse(requestParameters: InternalAdminApiCreateCannedResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseWriteResultDto>;

    /**
     * 
     * @summary Save a new email signature (audited)
     * @param {InternalAdminApiCreateEmailSignatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    createEmailSignature(requestParameters: InternalAdminApiCreateEmailSignatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailSignatureWriteResultDto>;

    /**
     * 
     * @summary Create an operator (audited) — returns a one-time password
     * @param {InternalAdminApiCreateOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    createOperator(requestParameters: InternalAdminApiCreateOperatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorOneTimePasswordDto>;

    /**
     * 
     * @summary Record a cash balance (audited)
     * @param {InternalAdminApiCreateOpsCashBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    createOpsCashBalance(requestParameters: InternalAdminApiCreateOpsCashBalanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsCashBalanceDto>;

    /**
     * 
     * @summary Create a cost item (audited)
     * @param {InternalAdminApiCreateOpsCostItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    createOpsCostItem(requestParameters: InternalAdminApiCreateOpsCostItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsCostItemDto>;

    /**
     * Applies to subscriptions created AFTER this point only — the discount rides appSubscriptionCreate.
     * @summary Create a voucher code (audited)
     * @param {InternalAdminApiCreateOpsVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    createOpsVoucher(requestParameters: InternalAdminApiCreateOpsVoucherRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsVoucherWriteResultDto>;

    /**
     * Stops new redemptions. Subscriptions that already carry the discount keep it. The code is never deleted: its usage rows would cascade away.
     * @summary Deactivate a voucher code (audited)
     * @param {InternalAdminApiDeactivateOpsVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    deactivateOpsVoucher(requestParameters: InternalAdminApiDeactivateOpsVoucherRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsVoucherWriteResultDto>;

    /**
     * 
     * @summary Delete a saved email signature (audited)
     * @param {InternalAdminApiDeleteEmailSignatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    deleteEmailSignature(requestParameters: InternalAdminApiDeleteEmailSignatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailSignatureDeleteResultDto>;

    /**
     * 
     * @summary Delete a cash balance (audited)
     * @param {InternalAdminApiDeleteOpsCashBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    deleteOpsCashBalance(requestParameters: InternalAdminApiDeleteOpsCashBalanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDeleteResultDto>;

    /**
     * For mistakes. A cancelled cost gets an end month instead, so past months stay.
     * @summary Delete a cost item (audited)
     * @param {InternalAdminApiDeleteOpsCostItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    deleteOpsCostItem(requestParameters: InternalAdminApiDeleteOpsCostItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDeleteResultDto>;

    /**
     * Traces the order through webhook events, attention items, durable failed jobs and its documents, reads the shop state and the order from Shopify, and returns one verdict token plus exactly one next action for the invoice family and for the refund/cancellation family. Writes an OperatorAuditLog row (order.diagnosis.view).
     * @summary Diagnose why an order has or lacks its invoice, credit note or Storno
     * @param {InternalAdminApiDiagnoseOpsOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    diagnoseOpsOrder(requestParameters: InternalAdminApiDiagnoseOpsOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDiagnosisDto>;

    /**
     * 
     * @summary Disable an operator (audited)
     * @param {InternalAdminApiDisableOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    disableOperator(requestParameters: InternalAdminApiDisableOperatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorDto>;

    /**
     * The stored bytes, decrypted, exactly as archived. Writes document.pdf.download to the operator audit log first.
     * @summary Download a document’s archived PDF (audited)
     * @param {InternalAdminApiDownloadOpsShopDocumentPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    downloadOpsShopDocumentPdf(requestParameters: InternalAdminApiDownloadOpsShopDocumentPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Re-enable an operator (audited)
     * @param {InternalAdminApiEnableOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    enableOperator(requestParameters: InternalAdminApiEnableOperatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorDto>;

    /**
     * Writes a durable OperatorAuditLog row, then re-checks each order against fresh data with the gap predicate and mints it through the single invoice writer (next sequential number, Rechnungsdatum = processed_at). Customer email is off unless sendCustomerEmail is true. At most 25 orders per call. Raises one merchant notice naming the period the new invoices are dated in.
     * @summary Mint invoices for previewed orders (audited)
     * @param {InternalAdminApiExecuteOpsPeriodBackfillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    executeOpsPeriodBackfill(requestParameters: InternalAdminApiExecuteOpsPeriodBackfillRequest, options?: RawAxiosRequestConfig): AxiosPromise<PeriodBackfillExecuteResultDto>;

    /**
     * Calls Shopify appSubscriptionTrialExtend for the shop\'s ACTIVE subscription while it is still in trial, at most 30 days per action. Writes the audit row before Shopify is called. A Shopify refusal (userErrors) is returned with extended=false, not thrown.
     * @summary Extend a running trial (audited)
     * @param {InternalAdminApiExtendOpsShopTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    extendOpsShopTrial(requestParameters: InternalAdminApiExtendOpsShopTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialExtensionResultDto>;

    /**
     * 
     * @summary Read one operator audit entry including its payload
     * @param {InternalAdminApiGetOperatorAuditEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getOperatorAuditEntry(requestParameters: InternalAdminApiGetOperatorAuditEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorAuditEntryDto>;

    /**
     * EUR, accrual. Default range: the last 12 months including the running one; at most 36 months.
     * @summary Operations report: P&L, SaaS metrics, unit economics, plan, runway
     * @param {InternalAdminApiGetOpsFinanceReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getOpsFinanceReport(requestParameters?: InternalAdminApiGetOpsFinanceReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsFinanceReportDto>;

    /**
     * The snapshot the collector builds every 15 s. Poll at most every 15 s; it never changes faster.
     * @summary Infrastructure: nodes, Load Balancer, database connection budget
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getOpsInfrastructure(options?: RawAxiosRequestConfig): AxiosPromise<OpsInfrastructureDto>;

    /**
     * 
     * @summary Partner API mirror status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getOpsPartnerSyncStatus(options?: RawAxiosRequestConfig): AxiosPromise<OpsPartnerStatusDto>;

    /**
     * Local subscription (both slots, cap, trial), trial-extension eligibility, TrialHistory, recent billing cycles, failed usage records, redeemed vouchers, subscription transition audit and earlier operator billing actions. DB only.
     * @summary Read a shop\'s billing detail
     * @param {InternalAdminApiGetOpsShopBillingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getOpsShopBilling(requestParameters: InternalAdminApiGetOpsShopBillingRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsBillingDto>;

    /**
     * Settings summary and lock state (no secrets), every Steuerberater invite (never the token hash), every export schedule with its recipients and their confirmation state — distinguishing a double-opt-in confirmation from a recipient the Kanzlei’s finalise created CONFIRMED — and the latest DATEV EXTF export jobs.
     * @summary Read a shop\'s DATEV invite, export recipients and last exports
     * @param {InternalAdminApiGetOpsShopDatevRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getOpsShopDatev(requestParameters: InternalAdminApiGetOpsShopDatevRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDatevOverviewDto>;

    /**
     * Identity, subscription, contract acceptance, setup, Shopify scope approval, open alerts and attention items, recent webhooks, documents, exports and tickets. Sections that cannot be read are null and named in `unavailable`.
     * @summary Read a shop file
     * @param {InternalAdminApiGetOpsShopFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getOpsShopFile(requestParameters: InternalAdminApiGetOpsShopFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopFileDto>;

    /**
     * queued while the worker runs it, then completed (the server accepted it — check your inbox) or failed (with the classified reason).
     * @summary Poll an SMTP test mail
     * @param {InternalAdminApiGetOpsShopSmtpTestStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getOpsShopSmtpTestStatus(requestParameters: InternalAdminApiGetOpsShopSmtpTestStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsSmtpTestStatusDto>;

    /**
     * 
     * @summary Get a shop’s document numbering state
     * @param {InternalAdminApiGetShopNumberingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    getShopNumbering(requestParameters: InternalAdminApiGetShopNumberingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopNumberingDto>;

    /**
     * 
     * @summary Change an operator password — returns a fresh bearer token
     * @param {InternalAdminApiInternalAdminControllerChangePasswordV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerChangePasswordV1(requestParameters: InternalAdminApiInternalAdminControllerChangePasswordV1Request, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto>;

    /**
     * 
     * @summary Discard all failed jobs in a queue (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerDiscardAllV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerDiscardAllV1(requestParameters: InternalAdminApiInternalAdminControllerDiscardAllV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueueDiscardAllResponseDto>;

    /**
     * 
     * @summary Discard (delete) a specific job (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerDiscardJobV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerDiscardJobV1(requestParameters: InternalAdminApiInternalAdminControllerDiscardJobV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueueJobActionResponseDto>;

    /**
     * 
     * @summary Get all queue statistics and health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerGetAllQueuesV1(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get full job detail including stacktrace
     * @param {InternalAdminApiInternalAdminControllerGetJobV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerGetJobV1(requestParameters: InternalAdminApiInternalAdminControllerGetJobV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary List jobs by state with pagination
     * @param {InternalAdminApiInternalAdminControllerGetJobsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerGetJobsV1(requestParameters: InternalAdminApiInternalAdminControllerGetJobsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get rolling 24h metrics history for charts
     * @param {InternalAdminApiInternalAdminControllerGetMetricsHistoryV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerGetMetricsHistoryV1(requestParameters?: InternalAdminApiInternalAdminControllerGetMetricsHistoryV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Reads the persistent FailedJob table (survives BullMQ removeOnFail eviction). Unresolved-only by default. Operator-only.
     * @summary List durable terminally-failed jobs
     * @param {InternalAdminApiInternalAdminControllerListFailedJobsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerListFailedJobsV1(requestParameters?: InternalAdminApiInternalAdminControllerListFailedJobsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<FailedJobsListDto>;

    /**
     * 
     * @summary Admin login — returns a signed bearer token
     * @param {InternalAdminApiInternalAdminControllerLoginV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerLoginV1(requestParameters: InternalAdminApiInternalAdminControllerLoginV1Request, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto>;

    /**
     * 
     * @summary Pause a queue (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerPauseV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerPauseV1(requestParameters: InternalAdminApiInternalAdminControllerPauseV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueuePauseResponseDto>;

    /**
     * 
     * @summary Resolve (clear) a durable failed-job record (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerResolveFailedJobV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerResolveFailedJobV1(requestParameters: InternalAdminApiInternalAdminControllerResolveFailedJobV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ResolveFailedJobResponseDto>;

    /**
     * 
     * @summary Resume a paused queue (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerResumeV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerResumeV1(requestParameters: InternalAdminApiInternalAdminControllerResumeV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueuePauseResponseDto>;

    /**
     * 
     * @summary Retry all failed jobs in a queue (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerRetryAllV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerRetryAllV1(requestParameters: InternalAdminApiInternalAdminControllerRetryAllV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueueRetryAllResponseDto>;

    /**
     * 
     * @summary Retry a specific job (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerRetryJobV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerRetryJobV1(requestParameters: InternalAdminApiInternalAdminControllerRetryJobV1Request, options?: RawAxiosRequestConfig): AxiosPromise<QueueJobActionResponseDto>;

    /**
     * Fetches the live subscription from Shopify Admin API and replays the webhook update handler to reconcile local DB. Operator-only (HMAC token from /internal-admin/auth/login).
     * @summary Force-sync subscription from Shopify
     * @param {InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    internalAdminControllerSyncSubscriptionFromShopifyV1(requestParameters: InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Active snippets by default; includeArchived adds archived ones. A category returns the snippets for that ticket category plus those that fit any. Shipped defaults that are missing are inserted first; an operator-edited default is never overwritten.
     * @summary List canned responses
     * @param {InternalAdminApiListCannedResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listCannedResponses(requestParameters?: InternalAdminApiListCannedResponsesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseListDto>;

    /**
     * 
     * @summary List saved email signatures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listEmailSignatures(options?: RawAxiosRequestConfig): AxiosPromise<EmailSignatureListDto>;

    /**
     * Filter by operator, action, shop domain and date. Payloads are not included — open one entry to read its payload (that read is itself audited).
     * @summary List operator audit entries
     * @param {InternalAdminApiListOperatorAuditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOperatorAudit(requestParameters?: InternalAdminApiListOperatorAuditRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorAuditListDto>;

    /**
     * 
     * @summary List operators
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOperators(options?: RawAxiosRequestConfig): AxiosPromise<OperatorListDto>;

    /**
     * 
     * @summary List plan figures of a year
     * @param {InternalAdminApiListOpsBudgetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOpsBudgets(requestParameters: InternalAdminApiListOpsBudgetsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsBudgetListDto>;

    /**
     * 
     * @summary List cash balances
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOpsCashBalances(options?: RawAxiosRequestConfig): AxiosPromise<OpsCashBalanceListDto>;

    /**
     * 
     * @summary List cost items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOpsCostItems(options?: RawAxiosRequestConfig): AxiosPromise<OpsCostItemListDto>;

    /**
     * 
     * @summary List stored USD→EUR month rates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOpsFxRates(options?: RawAxiosRequestConfig): AxiosPromise<OpsFxRateListDto>;

    /**
     * Newest first across invoices, credit notes and cancellation invoices, 25 per page. With q, the support document lookup (document number, order name or order id) — unpaged, capped, and `truncated` says so.
     * @summary List or search a shop’s documents
     * @param {InternalAdminApiListOpsShopDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOpsShopDocuments(requestParameters: InternalAdminApiListOpsShopDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentListDto>;

    /**
     * Document and export mail only — `notLogged` names the mail that never creates a row. SENT means the relay accepted the message, not that it arrived; bounces are not recorded.
     * @summary Read a shop’s email delivery log
     * @param {InternalAdminApiListOpsShopEmailLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOpsShopEmailLog(requestParameters: InternalAdminApiListOpsShopEmailLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsEmailLogDto>;

    /**
     * Shop identity, subscription id and date only. onCurrentSubscription tells whether the discount is still on the shop’s subscription.
     * @summary List the shops that redeemed a voucher code
     * @param {InternalAdminApiListOpsVoucherUsagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOpsVoucherUsages(requestParameters: InternalAdminApiListOpsVoucherUsagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsVoucherUsageListDto>;

    /**
     * Newest first, with the currentUsage counter AND the usage-row count (both can under-count). Fixed amounts are in billingCurrency (USD).
     * @summary List voucher codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    listOpsVouchers(options?: RawAxiosRequestConfig): AxiosPromise<OpsVoucherListDto>;

    /**
     * Writes an OperatorAuditLog row with the reason or the ticket, and returns a grant valid for two hours. Every read of the shop requires the grant in the X-Ops-Shop-Access header.
     * @summary Open a shop with a reason (audited)
     * @param {InternalAdminApiOpenOpsShopAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    openOpsShopAccess(requestParameters: InternalAdminApiOpenOpsShopAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopAccessGrantDto>;

    /**
     * Lists the paid orders in the period that the daily reconciliation would call a gap (the SAME predicate), the orders it leaves alone grouped by reason, whether the scan was truncated, and the window actually scanned (clamped to Shopify’s 60-day read window and to the invoicing anchor). Returns a preview token that arms execute for 15 minutes.
     * @summary Preview a period backfill (dry run)
     * @param {InternalAdminApiPreviewOpsPeriodBackfillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    previewOpsPeriodBackfill(requestParameters: InternalAdminApiPreviewOpsPeriodBackfillRequest, options?: RawAxiosRequestConfig): AxiosPromise<PeriodBackfillPreviewDto>;

    /**
     * The next two free invoice numbers (Storno, then the new invoice) and the refusal the reissue would answer with. Reserves nothing; another document minted in between moves the numbers.
     * @summary Preview a reissue: the numbers it would draw and any refusal
     * @param {InternalAdminApiPreviewOpsShopInvoiceReissueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    previewOpsShopInvoiceReissue(requestParameters: InternalAdminApiPreviewOpsShopInvoiceReissueRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentReissuePreviewDto>;

    /**
     * Only for a document with NO stored PDF. An archived PDF is never re-rendered (§147 AO) — resend it instead.
     * @summary Regenerate a missing PDF (audited)
     * @param {InternalAdminApiRegenerateOpsShopDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    regenerateOpsShopDocument(requestParameters: InternalAdminApiRegenerateOpsShopDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentActionResultDto>;

    /**
     * Re-reads the order from Shopify, writes a Stornorechnung for the ACTIVE immutable invoice and a new invoice through the normal correction pipeline, in one transaction and the gapless sequence. Works for a document that was never emailed (CREATED with an archived PDF). An optional customer VAT ID is format-checked, stored on the customer and printed on the new invoice. The Shopify order is never changed. Both documents then go through the normal PDF and email jobs.
     * @summary Reissue an invoice: Storno plus a new invoice from the current order (audited)
     * @param {InternalAdminApiReissueOpsShopInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    reissueOpsShopInvoice(requestParameters: InternalAdminApiReissueOpsShopInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentReissueResultDto>;

    /**
     * Same path as the merchant\'s resend: mints a NEW token, so the Kanzlei\'s previous link stops working even if this send fails. Only the shop\'s newest PENDING invite is resendable. A successful send closes DATEV_INVITE_UNDELIVERED by itself. Rate-limited per shop.
     * @summary Resend the pending Steuerberater invite (audited)
     * @param {InternalAdminApiResendOpsDatevInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    resendOpsDatevInvite(requestParameters: InternalAdminApiResendOpsDatevInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDatevInviteResendResultDto>;

    /**
     * Same path as the merchant\'s resend: rotates the confirmation token, so the recipient\'s earlier link stops working. PENDING and EXPIRED recipients only — a CONFIRMED one would be reset to pending, a REJECTED one declined. Rate-limited per shop.
     * @summary Resend an export recipient\'s confirmation email (audited)
     * @param {InternalAdminApiResendOpsRecipientConfirmationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    resendOpsRecipientConfirmation(requestParameters: InternalAdminApiResendOpsRecipientConfirmationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsRecipientResendResultDto>;

    /**
     * Queues the merchant’s own resend of the ARCHIVED PDF. recipientOverride needs the ticketId of a support ticket of this shop. Refused for a document the shop is holding for its own first send (automatic sending off). A failed send still raises the merchant’s own failure alert.
     * @summary Resend a document email (audited)
     * @param {InternalAdminApiResendOpsShopDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    resendOpsShopDocument(requestParameters: InternalAdminApiResendOpsShopDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsDocumentActionResultDto>;

    /**
     * 
     * @summary Reset an operator password (audited) — returns a one-time password
     * @param {InternalAdminApiResetOperatorPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    resetOperatorPassword(requestParameters: InternalAdminApiResetOperatorPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorOneTimePasswordDto>;

    /**
     * 
     * @summary Restore an archived canned response (audited)
     * @param {InternalAdminApiRestoreCannedResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    restoreCannedResponse(requestParameters: InternalAdminApiRestoreCannedResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseWriteResultDto>;

    /**
     * Returns identity only (domain, name, which field matched). Opening a shop needs a reason — see openOpsShopAccess.
     * @summary Find shops by domain, name or email
     * @param {InternalAdminApiSearchOpsShopsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    searchOpsShops(requestParameters: InternalAdminApiSearchOpsShopsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopSearchResultDto>;

    /**
     * The worker sends an export-shaped test through the merchant’s SMTP to YOUR operator address — never to anyone else, and without the connection probe that writes an error onto the merchant’s settings. Not applicable on our fallback relay or without a complete SMTP configuration.
     * @summary Send an SMTP test mail to yourself (audited)
     * @param {InternalAdminApiSendOpsShopSmtpTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    sendOpsShopSmtpTest(requestParameters: InternalAdminApiSendOpsShopSmtpTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsSmtpTestResultDto>;

    /**
     * A null amount removes the figure. Returns the whole year.
     * @summary Set or clear one plan figure (audited)
     * @param {InternalAdminApiSetOpsBudgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    setOpsBudget(requestParameters: InternalAdminApiSetOpsBudgetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsBudgetListDto>;

    /**
     * Stored as MANUAL; an ECB fetch never replaces it.
     * @summary Override a month’s USD→EUR rate (audited)
     * @param {InternalAdminApiSetOpsFxRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    setOpsFxRate(requestParameters: InternalAdminApiSetOpsFxRateRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsFxRateDto>;

    /**
     * Runs in the background; poll the status. Idempotent — a re-pull changes nothing.
     * @summary Pull the Partner API now
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    startOpsPartnerSync(options?: RawAxiosRequestConfig): AxiosPromise<OpsPartnerSyncStartDto>;

    /**
     * expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
     * @summary Edit a canned response (audited, optimistic concurrency)
     * @param {InternalAdminApiUpdateCannedResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    updateCannedResponse(requestParameters: InternalAdminApiUpdateCannedResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CannedResponseWriteResultDto>;

    /**
     * Replaces the whole content. expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
     * @summary Save an edited email signature (audited, optimistic concurrency)
     * @param {InternalAdminApiUpdateEmailSignatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    updateEmailSignature(requestParameters: InternalAdminApiUpdateEmailSignatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailSignatureWriteResultDto>;

    /**
     * 
     * @summary Edit an operator profile (audited)
     * @param {InternalAdminApiUpdateOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    updateOperator(requestParameters: InternalAdminApiUpdateOperatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorDto>;

    /**
     * Restates every month the item ran in. To record a price change, end the item and start a new one.
     * @summary Edit a cost item (audited)
     * @param {InternalAdminApiUpdateOpsCostItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    updateOpsCostItem(requestParameters: InternalAdminApiUpdateOpsCostItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpsCostItemDto>;

    /**
     * 
     * @summary Change a shop’s onboarding-frozen document numbering
     * @param {InternalAdminApiUpdateShopNumberingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApiInterface
     */
    updateShopNumbering(requestParameters: InternalAdminApiUpdateShopNumberingRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateShopNumberingResponseDto>;

}

/**
 * Request parameters for archiveCannedResponse operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiArchiveCannedResponseRequest
 */
export interface InternalAdminApiArchiveCannedResponseRequest {
    /**
     * SupportCannedResponse id
     * @type {string}
     * @memberof InternalAdminApiArchiveCannedResponse
     */
    readonly id: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiArchiveCannedResponse
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for backfillInvoice operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiBackfillInvoiceRequest
 */
export interface InternalAdminApiBackfillInvoiceRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiBackfillInvoice
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiBackfillInvoice
     */
    readonly xOpsShopAccess: string

    /**
     * 
     * @type {BackfillInvoiceDto}
     * @memberof InternalAdminApiBackfillInvoice
     */
    readonly backfillInvoiceDto: BackfillInvoiceDto
}

/**
 * Request parameters for broadcastAlert operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiBroadcastAlertRequest
 */
export interface InternalAdminApiBroadcastAlertRequest {
    /**
     * 
     * @type {BroadcastAlertDto}
     * @memberof InternalAdminApiBroadcastAlert
     */
    readonly broadcastAlertDto: BroadcastAlertDto
}

/**
 * Request parameters for clearOpsFxRate operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiClearOpsFxRateRequest
 */
export interface InternalAdminApiClearOpsFxRateRequest {
    /**
     * YYYY-MM
     * @type {string}
     * @memberof InternalAdminApiClearOpsFxRate
     */
    readonly month: string
}

/**
 * Request parameters for createCannedResponse operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiCreateCannedResponseRequest
 */
export interface InternalAdminApiCreateCannedResponseRequest {
    /**
     * 
     * @type {CreateCannedResponseDto}
     * @memberof InternalAdminApiCreateCannedResponse
     */
    readonly createCannedResponseDto: CreateCannedResponseDto
}

/**
 * Request parameters for createEmailSignature operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiCreateEmailSignatureRequest
 */
export interface InternalAdminApiCreateEmailSignatureRequest {
    /**
     * 
     * @type {CreateEmailSignatureDto}
     * @memberof InternalAdminApiCreateEmailSignature
     */
    readonly createEmailSignatureDto: CreateEmailSignatureDto
}

/**
 * Request parameters for createOperator operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiCreateOperatorRequest
 */
export interface InternalAdminApiCreateOperatorRequest {
    /**
     * 
     * @type {CreateOperatorDto}
     * @memberof InternalAdminApiCreateOperator
     */
    readonly createOperatorDto: CreateOperatorDto
}

/**
 * Request parameters for createOpsCashBalance operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiCreateOpsCashBalanceRequest
 */
export interface InternalAdminApiCreateOpsCashBalanceRequest {
    /**
     * 
     * @type {OpsCashBalanceInputDto}
     * @memberof InternalAdminApiCreateOpsCashBalance
     */
    readonly opsCashBalanceInputDto: OpsCashBalanceInputDto
}

/**
 * Request parameters for createOpsCostItem operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiCreateOpsCostItemRequest
 */
export interface InternalAdminApiCreateOpsCostItemRequest {
    /**
     * 
     * @type {OpsCostItemInputDto}
     * @memberof InternalAdminApiCreateOpsCostItem
     */
    readonly opsCostItemInputDto: OpsCostItemInputDto
}

/**
 * Request parameters for createOpsVoucher operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiCreateOpsVoucherRequest
 */
export interface InternalAdminApiCreateOpsVoucherRequest {
    /**
     * 
     * @type {CreateVoucherRequestDto}
     * @memberof InternalAdminApiCreateOpsVoucher
     */
    readonly createVoucherRequestDto: CreateVoucherRequestDto
}

/**
 * Request parameters for deactivateOpsVoucher operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiDeactivateOpsVoucherRequest
 */
export interface InternalAdminApiDeactivateOpsVoucherRequest {
    /**
     * VoucherCode id
     * @type {string}
     * @memberof InternalAdminApiDeactivateOpsVoucher
     */
    readonly id: string

    /**
     * 
     * @type {DeactivateVoucherRequestDto}
     * @memberof InternalAdminApiDeactivateOpsVoucher
     */
    readonly deactivateVoucherRequestDto: DeactivateVoucherRequestDto
}

/**
 * Request parameters for deleteEmailSignature operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiDeleteEmailSignatureRequest
 */
export interface InternalAdminApiDeleteEmailSignatureRequest {
    /**
     * EmailSignature id
     * @type {string}
     * @memberof InternalAdminApiDeleteEmailSignature
     */
    readonly id: string
}

/**
 * Request parameters for deleteOpsCashBalance operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiDeleteOpsCashBalanceRequest
 */
export interface InternalAdminApiDeleteOpsCashBalanceRequest {
    /**
     * FinanceCashBalance id
     * @type {string}
     * @memberof InternalAdminApiDeleteOpsCashBalance
     */
    readonly id: string
}

/**
 * Request parameters for deleteOpsCostItem operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiDeleteOpsCostItemRequest
 */
export interface InternalAdminApiDeleteOpsCostItemRequest {
    /**
     * FinanceCostItem id
     * @type {string}
     * @memberof InternalAdminApiDeleteOpsCostItem
     */
    readonly id: string
}

/**
 * Request parameters for diagnoseOpsOrder operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiDiagnoseOpsOrderRequest
 */
export interface InternalAdminApiDiagnoseOpsOrderRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiDiagnoseOpsOrder
     */
    readonly shopId: string

    /**
     * An order name (&#x60;#1234&#x60;, &#x60;1234&#x60;, or a custom-prefixed name as Shopify prints it), a numeric Shopify order id, or an order gid.
     * @type {string}
     * @memberof InternalAdminApiDiagnoseOpsOrder
     */
    readonly order: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiDiagnoseOpsOrder
     */
    readonly xOpsShopAccess: string
}

/**
 * Request parameters for disableOperator operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiDisableOperatorRequest
 */
export interface InternalAdminApiDisableOperatorRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiDisableOperator
     */
    readonly username: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiDisableOperator
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for downloadOpsShopDocumentPdf operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiDownloadOpsShopDocumentPdfRequest
 */
export interface InternalAdminApiDownloadOpsShopDocumentPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiDownloadOpsShopDocumentPdf
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiDownloadOpsShopDocumentPdf
     */
    readonly shopId: string

    /**
     * 
     * @type {'invoice' | 'creditNote' | 'cancellation'}
     * @memberof InternalAdminApiDownloadOpsShopDocumentPdf
     */
    readonly kind: DownloadOpsShopDocumentPdfKindEnum

    /**
     * Document id
     * @type {string}
     * @memberof InternalAdminApiDownloadOpsShopDocumentPdf
     */
    readonly documentId: string
}

/**
 * Request parameters for enableOperator operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiEnableOperatorRequest
 */
export interface InternalAdminApiEnableOperatorRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiEnableOperator
     */
    readonly username: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiEnableOperator
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for executeOpsPeriodBackfill operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiExecuteOpsPeriodBackfillRequest
 */
export interface InternalAdminApiExecuteOpsPeriodBackfillRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiExecuteOpsPeriodBackfill
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiExecuteOpsPeriodBackfill
     */
    readonly xOpsShopAccess: string

    /**
     * 
     * @type {PeriodBackfillExecuteRequestDto}
     * @memberof InternalAdminApiExecuteOpsPeriodBackfill
     */
    readonly periodBackfillExecuteRequestDto: PeriodBackfillExecuteRequestDto
}

/**
 * Request parameters for extendOpsShopTrial operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiExtendOpsShopTrialRequest
 */
export interface InternalAdminApiExtendOpsShopTrialRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiExtendOpsShopTrial
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiExtendOpsShopTrial
     */
    readonly xOpsShopAccess: string

    /**
     * 
     * @type {TrialExtensionRequestDto}
     * @memberof InternalAdminApiExtendOpsShopTrial
     */
    readonly trialExtensionRequestDto: TrialExtensionRequestDto
}

/**
 * Request parameters for getOperatorAuditEntry operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiGetOperatorAuditEntryRequest
 */
export interface InternalAdminApiGetOperatorAuditEntryRequest {
    /**
     * OperatorAuditLog id
     * @type {string}
     * @memberof InternalAdminApiGetOperatorAuditEntry
     */
    readonly id: string
}

/**
 * Request parameters for getOpsFinanceReport operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiGetOpsFinanceReportRequest
 */
export interface InternalAdminApiGetOpsFinanceReportRequest {
    /**
     * First month, YYYY-MM.
     * @type {string}
     * @memberof InternalAdminApiGetOpsFinanceReport
     */
    readonly from?: string

    /**
     * Last month, YYYY-MM.
     * @type {string}
     * @memberof InternalAdminApiGetOpsFinanceReport
     */
    readonly to?: string
}

/**
 * Request parameters for getOpsShopBilling operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiGetOpsShopBillingRequest
 */
export interface InternalAdminApiGetOpsShopBillingRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopBilling
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopBilling
     */
    readonly xOpsShopAccess: string
}

/**
 * Request parameters for getOpsShopDatev operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiGetOpsShopDatevRequest
 */
export interface InternalAdminApiGetOpsShopDatevRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopDatev
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopDatev
     */
    readonly xOpsShopAccess: string
}

/**
 * Request parameters for getOpsShopFile operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiGetOpsShopFileRequest
 */
export interface InternalAdminApiGetOpsShopFileRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopFile
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopFile
     */
    readonly xOpsShopAccess: string
}

/**
 * Request parameters for getOpsShopSmtpTestStatus operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiGetOpsShopSmtpTestStatusRequest
 */
export interface InternalAdminApiGetOpsShopSmtpTestStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopSmtpTestStatus
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopSmtpTestStatus
     */
    readonly shopId: string

    /**
     * From sendOpsShopSmtpTest
     * @type {string}
     * @memberof InternalAdminApiGetOpsShopSmtpTestStatus
     */
    readonly jobId: string
}

/**
 * Request parameters for getShopNumbering operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiGetShopNumberingRequest
 */
export interface InternalAdminApiGetShopNumberingRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiGetShopNumbering
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiGetShopNumbering
     */
    readonly xOpsShopAccess: string
}

/**
 * Request parameters for internalAdminControllerChangePasswordV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerChangePasswordV1Request
 */
export interface InternalAdminApiInternalAdminControllerChangePasswordV1Request {
    /**
     * 
     * @type {ChangePasswordDto}
     * @memberof InternalAdminApiInternalAdminControllerChangePasswordV1
     */
    readonly changePasswordDto: ChangePasswordDto
}

/**
 * Request parameters for internalAdminControllerDiscardAllV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerDiscardAllV1Request
 */
export interface InternalAdminApiInternalAdminControllerDiscardAllV1Request {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerDiscardAllV1
     */
    readonly name: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiInternalAdminControllerDiscardAllV1
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for internalAdminControllerDiscardJobV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerDiscardJobV1Request
 */
export interface InternalAdminApiInternalAdminControllerDiscardJobV1Request {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerDiscardJobV1
     */
    readonly name: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerDiscardJobV1
     */
    readonly id: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiInternalAdminControllerDiscardJobV1
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for internalAdminControllerGetJobV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerGetJobV1Request
 */
export interface InternalAdminApiInternalAdminControllerGetJobV1Request {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerGetJobV1
     */
    readonly name: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerGetJobV1
     */
    readonly id: string
}

/**
 * Request parameters for internalAdminControllerGetJobsV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerGetJobsV1Request
 */
export interface InternalAdminApiInternalAdminControllerGetJobsV1Request {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerGetJobsV1
     */
    readonly name: string

    /**
     * Filter by shop ID or domain
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerGetJobsV1
     */
    readonly shopId?: string

    /**
     * Search by job name, ID, error, or data preview
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerGetJobsV1
     */
    readonly search?: string

    /**
     * Items per page (max 100)
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerGetJobsV1
     */
    readonly limit?: string

    /**
     * Page number (1-based)
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerGetJobsV1
     */
    readonly page?: string

    /**
     * Job state filter
     * @type {'waiting' | 'active' | 'completed' | 'failed' | 'delayed'}
     * @memberof InternalAdminApiInternalAdminControllerGetJobsV1
     */
    readonly state?: InternalAdminControllerGetJobsV1StateEnum
}

/**
 * Request parameters for internalAdminControllerGetMetricsHistoryV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerGetMetricsHistoryV1Request
 */
export interface InternalAdminApiInternalAdminControllerGetMetricsHistoryV1Request {
    /**
     * Number of minutes of history (1–1440, default 60)
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerGetMetricsHistoryV1
     */
    readonly minutes?: string
}

/**
 * Request parameters for internalAdminControllerListFailedJobsV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerListFailedJobsV1Request
 */
export interface InternalAdminApiInternalAdminControllerListFailedJobsV1Request {
    /**
     * Filter by queue name.
     * @type {'invoice-processing' | 'export-processing' | 'webhook-processing' | 'data-retention'}
     * @memberof InternalAdminApiInternalAdminControllerListFailedJobsV1
     */
    readonly queueName?: InternalAdminControllerListFailedJobsV1QueueNameEnum

    /**
     * Filter by shop ID (best-effort field; some jobs have no shop).
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerListFailedJobsV1
     */
    readonly shopId?: string

    /**
     * Whether to include already-resolved records. Defaults to false (unresolved only).
     * @type {boolean}
     * @memberof InternalAdminApiInternalAdminControllerListFailedJobsV1
     */
    readonly includeResolved?: boolean

    /**
     * Page number (1-based).
     * @type {number}
     * @memberof InternalAdminApiInternalAdminControllerListFailedJobsV1
     */
    readonly page?: number

    /**
     * Items per page (max 100).
     * @type {number}
     * @memberof InternalAdminApiInternalAdminControllerListFailedJobsV1
     */
    readonly limit?: number
}

/**
 * Request parameters for internalAdminControllerLoginV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerLoginV1Request
 */
export interface InternalAdminApiInternalAdminControllerLoginV1Request {
    /**
     * 
     * @type {LoginDto}
     * @memberof InternalAdminApiInternalAdminControllerLoginV1
     */
    readonly loginDto: LoginDto
}

/**
 * Request parameters for internalAdminControllerPauseV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerPauseV1Request
 */
export interface InternalAdminApiInternalAdminControllerPauseV1Request {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerPauseV1
     */
    readonly name: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiInternalAdminControllerPauseV1
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for internalAdminControllerResolveFailedJobV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerResolveFailedJobV1Request
 */
export interface InternalAdminApiInternalAdminControllerResolveFailedJobV1Request {
    /**
     * FailedJob record id
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerResolveFailedJobV1
     */
    readonly id: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiInternalAdminControllerResolveFailedJobV1
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for internalAdminControllerResumeV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerResumeV1Request
 */
export interface InternalAdminApiInternalAdminControllerResumeV1Request {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerResumeV1
     */
    readonly name: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiInternalAdminControllerResumeV1
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for internalAdminControllerRetryAllV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerRetryAllV1Request
 */
export interface InternalAdminApiInternalAdminControllerRetryAllV1Request {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerRetryAllV1
     */
    readonly name: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiInternalAdminControllerRetryAllV1
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for internalAdminControllerRetryJobV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerRetryJobV1Request
 */
export interface InternalAdminApiInternalAdminControllerRetryJobV1Request {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerRetryJobV1
     */
    readonly name: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerRetryJobV1
     */
    readonly id: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiInternalAdminControllerRetryJobV1
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for internalAdminControllerSyncSubscriptionFromShopifyV1 operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1Request
 */
export interface InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1Request {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1
     */
    readonly xOpsShopAccess: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for listCannedResponses operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiListCannedResponsesRequest
 */
export interface InternalAdminApiListCannedResponsesRequest {
    /**
     * Include archived snippets (the management page). The picker leaves this off.
     * @type {boolean}
     * @memberof InternalAdminApiListCannedResponses
     */
    readonly includeArchived?: boolean

    /**
     * Only snippets for this ticket category, plus those that fit any category (category null).
     * @type {'QUESTION' | 'BUG' | 'FEATURE_REQUEST' | 'FEEDBACK' | 'BILLING' | 'TAX_COMPLIANCE' | 'DATA_EXPORT' | 'ONBOARDING' | 'OTHER'}
     * @memberof InternalAdminApiListCannedResponses
     */
    readonly category?: ListCannedResponsesCategoryEnum

    /**
     * Case-insensitive search over title and both bodies.
     * @type {string}
     * @memberof InternalAdminApiListCannedResponses
     */
    readonly q?: string
}

/**
 * Request parameters for listOperatorAudit operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiListOperatorAuditRequest
 */
export interface InternalAdminApiListOperatorAuditRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiListOperatorAudit
     */
    readonly operator?: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiListOperatorAudit
     */
    readonly action?: string

    /**
     * Exact shop domain, or &#x60;*&#x60; for cross-shop actions.
     * @type {string}
     * @memberof InternalAdminApiListOperatorAudit
     */
    readonly shopDomain?: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiListOperatorAudit
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiListOperatorAudit
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof InternalAdminApiListOperatorAudit
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof InternalAdminApiListOperatorAudit
     */
    readonly limit?: number
}

/**
 * Request parameters for listOpsBudgets operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiListOpsBudgetsRequest
 */
export interface InternalAdminApiListOpsBudgetsRequest {
    /**
     * 
     * @type {number}
     * @memberof InternalAdminApiListOpsBudgets
     */
    readonly year: number
}

/**
 * Request parameters for listOpsShopDocuments operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiListOpsShopDocumentsRequest
 */
export interface InternalAdminApiListOpsShopDocumentsRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiListOpsShopDocuments
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiListOpsShopDocuments
     */
    readonly shopId: string

    /**
     * A document number as the merchant quoted it (RE-26392, 26392), an order name (#1001) or an order id. Uses the support document lookup; paging does not apply to a search.
     * @type {string}
     * @memberof InternalAdminApiListOpsShopDocuments
     */
    readonly q?: string

    /**
     * 
     * @type {OpsDocumentKind}
     * @memberof InternalAdminApiListOpsShopDocuments
     */
    readonly kind?: OpsDocumentKind

    /**
     * 
     * @type {number}
     * @memberof InternalAdminApiListOpsShopDocuments
     */
    readonly page?: number
}

/**
 * Request parameters for listOpsShopEmailLog operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiListOpsShopEmailLogRequest
 */
export interface InternalAdminApiListOpsShopEmailLogRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiListOpsShopEmailLog
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiListOpsShopEmailLog
     */
    readonly shopId: string

    /**
     * Part of the recipient address (case-insensitive).
     * @type {string}
     * @memberof InternalAdminApiListOpsShopEmailLog
     */
    readonly recipient?: string

    /**
     * 
     * @type {OpsEmailFilterStatus}
     * @memberof InternalAdminApiListOpsShopEmailLog
     */
    readonly status?: OpsEmailFilterStatus

    /**
     * 
     * @type {number}
     * @memberof InternalAdminApiListOpsShopEmailLog
     */
    readonly page?: number
}

/**
 * Request parameters for listOpsVoucherUsages operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiListOpsVoucherUsagesRequest
 */
export interface InternalAdminApiListOpsVoucherUsagesRequest {
    /**
     * VoucherCode id
     * @type {string}
     * @memberof InternalAdminApiListOpsVoucherUsages
     */
    readonly id: string
}

/**
 * Request parameters for openOpsShopAccess operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiOpenOpsShopAccessRequest
 */
export interface InternalAdminApiOpenOpsShopAccessRequest {
    /**
     * Shop id or myshopify domain
     * @type {string}
     * @memberof InternalAdminApiOpenOpsShopAccess
     */
    readonly shopId: string

    /**
     * 
     * @type {ShopAccessRequestDto}
     * @memberof InternalAdminApiOpenOpsShopAccess
     */
    readonly shopAccessRequestDto: ShopAccessRequestDto
}

/**
 * Request parameters for previewOpsPeriodBackfill operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiPreviewOpsPeriodBackfillRequest
 */
export interface InternalAdminApiPreviewOpsPeriodBackfillRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiPreviewOpsPeriodBackfill
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiPreviewOpsPeriodBackfill
     */
    readonly xOpsShopAccess: string

    /**
     * 
     * @type {PeriodBackfillPreviewRequestDto}
     * @memberof InternalAdminApiPreviewOpsPeriodBackfill
     */
    readonly periodBackfillPreviewRequestDto: PeriodBackfillPreviewRequestDto
}

/**
 * Request parameters for previewOpsShopInvoiceReissue operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiPreviewOpsShopInvoiceReissueRequest
 */
export interface InternalAdminApiPreviewOpsShopInvoiceReissueRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiPreviewOpsShopInvoiceReissue
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiPreviewOpsShopInvoiceReissue
     */
    readonly shopId: string

    /**
     * Invoice id
     * @type {string}
     * @memberof InternalAdminApiPreviewOpsShopInvoiceReissue
     */
    readonly documentId: string
}

/**
 * Request parameters for regenerateOpsShopDocument operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiRegenerateOpsShopDocumentRequest
 */
export interface InternalAdminApiRegenerateOpsShopDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiRegenerateOpsShopDocument
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiRegenerateOpsShopDocument
     */
    readonly shopId: string

    /**
     * 
     * @type {'invoice' | 'creditNote' | 'cancellation'}
     * @memberof InternalAdminApiRegenerateOpsShopDocument
     */
    readonly kind: RegenerateOpsShopDocumentKindEnum

    /**
     * Document id
     * @type {string}
     * @memberof InternalAdminApiRegenerateOpsShopDocument
     */
    readonly documentId: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiRegenerateOpsShopDocument
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for reissueOpsShopInvoice operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiReissueOpsShopInvoiceRequest
 */
export interface InternalAdminApiReissueOpsShopInvoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiReissueOpsShopInvoice
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiReissueOpsShopInvoice
     */
    readonly shopId: string

    /**
     * Invoice id
     * @type {string}
     * @memberof InternalAdminApiReissueOpsShopInvoice
     */
    readonly documentId: string

    /**
     * 
     * @type {OpsDocumentReissueDto}
     * @memberof InternalAdminApiReissueOpsShopInvoice
     */
    readonly opsDocumentReissueDto: OpsDocumentReissueDto
}

/**
 * Request parameters for resendOpsDatevInvite operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiResendOpsDatevInviteRequest
 */
export interface InternalAdminApiResendOpsDatevInviteRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiResendOpsDatevInvite
     */
    readonly shopId: string

    /**
     * DatevAccountantInvite id
     * @type {string}
     * @memberof InternalAdminApiResendOpsDatevInvite
     */
    readonly inviteId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiResendOpsDatevInvite
     */
    readonly xOpsShopAccess: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiResendOpsDatevInvite
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for resendOpsRecipientConfirmation operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiResendOpsRecipientConfirmationRequest
 */
export interface InternalAdminApiResendOpsRecipientConfirmationRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiResendOpsRecipientConfirmation
     */
    readonly shopId: string

    /**
     * ScheduleRecipient id
     * @type {string}
     * @memberof InternalAdminApiResendOpsRecipientConfirmation
     */
    readonly recipientId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiResendOpsRecipientConfirmation
     */
    readonly xOpsShopAccess: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiResendOpsRecipientConfirmation
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for resendOpsShopDocument operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiResendOpsShopDocumentRequest
 */
export interface InternalAdminApiResendOpsShopDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiResendOpsShopDocument
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiResendOpsShopDocument
     */
    readonly shopId: string

    /**
     * 
     * @type {'invoice' | 'creditNote' | 'cancellation'}
     * @memberof InternalAdminApiResendOpsShopDocument
     */
    readonly kind: ResendOpsShopDocumentKindEnum

    /**
     * Document id
     * @type {string}
     * @memberof InternalAdminApiResendOpsShopDocument
     */
    readonly documentId: string

    /**
     * 
     * @type {OpsDocumentResendDto}
     * @memberof InternalAdminApiResendOpsShopDocument
     */
    readonly opsDocumentResendDto: OpsDocumentResendDto
}

/**
 * Request parameters for resetOperatorPassword operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiResetOperatorPasswordRequest
 */
export interface InternalAdminApiResetOperatorPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiResetOperatorPassword
     */
    readonly username: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiResetOperatorPassword
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for restoreCannedResponse operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiRestoreCannedResponseRequest
 */
export interface InternalAdminApiRestoreCannedResponseRequest {
    /**
     * SupportCannedResponse id
     * @type {string}
     * @memberof InternalAdminApiRestoreCannedResponse
     */
    readonly id: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiRestoreCannedResponse
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for searchOpsShops operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiSearchOpsShopsRequest
 */
export interface InternalAdminApiSearchOpsShopsRequest {
    /**
     * Part of a shop domain, shop name or legal name, or an email the shop uses (support, SMTP sender, a staff login).
     * @type {string}
     * @memberof InternalAdminApiSearchOpsShops
     */
    readonly q: string
}

/**
 * Request parameters for sendOpsShopSmtpTest operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiSendOpsShopSmtpTestRequest
 */
export interface InternalAdminApiSendOpsShopSmtpTestRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiSendOpsShopSmtpTest
     */
    readonly xOpsShopAccess: string

    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiSendOpsShopSmtpTest
     */
    readonly shopId: string

    /**
     * 
     * @type {OperatorReasonDto}
     * @memberof InternalAdminApiSendOpsShopSmtpTest
     */
    readonly operatorReasonDto: OperatorReasonDto
}

/**
 * Request parameters for setOpsBudget operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiSetOpsBudgetRequest
 */
export interface InternalAdminApiSetOpsBudgetRequest {
    /**
     * 
     * @type {OpsBudgetInputDto}
     * @memberof InternalAdminApiSetOpsBudget
     */
    readonly opsBudgetInputDto: OpsBudgetInputDto
}

/**
 * Request parameters for setOpsFxRate operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiSetOpsFxRateRequest
 */
export interface InternalAdminApiSetOpsFxRateRequest {
    /**
     * YYYY-MM
     * @type {string}
     * @memberof InternalAdminApiSetOpsFxRate
     */
    readonly month: string

    /**
     * 
     * @type {OpsFxRateInputDto}
     * @memberof InternalAdminApiSetOpsFxRate
     */
    readonly opsFxRateInputDto: OpsFxRateInputDto
}

/**
 * Request parameters for updateCannedResponse operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiUpdateCannedResponseRequest
 */
export interface InternalAdminApiUpdateCannedResponseRequest {
    /**
     * SupportCannedResponse id
     * @type {string}
     * @memberof InternalAdminApiUpdateCannedResponse
     */
    readonly id: string

    /**
     * 
     * @type {UpdateCannedResponseDto}
     * @memberof InternalAdminApiUpdateCannedResponse
     */
    readonly updateCannedResponseDto: UpdateCannedResponseDto
}

/**
 * Request parameters for updateEmailSignature operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiUpdateEmailSignatureRequest
 */
export interface InternalAdminApiUpdateEmailSignatureRequest {
    /**
     * EmailSignature id
     * @type {string}
     * @memberof InternalAdminApiUpdateEmailSignature
     */
    readonly id: string

    /**
     * 
     * @type {UpdateEmailSignatureDto}
     * @memberof InternalAdminApiUpdateEmailSignature
     */
    readonly updateEmailSignatureDto: UpdateEmailSignatureDto
}

/**
 * Request parameters for updateOperator operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiUpdateOperatorRequest
 */
export interface InternalAdminApiUpdateOperatorRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiUpdateOperator
     */
    readonly username: string

    /**
     * 
     * @type {UpdateOperatorDto}
     * @memberof InternalAdminApiUpdateOperator
     */
    readonly updateOperatorDto: UpdateOperatorDto
}

/**
 * Request parameters for updateOpsCostItem operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiUpdateOpsCostItemRequest
 */
export interface InternalAdminApiUpdateOpsCostItemRequest {
    /**
     * FinanceCostItem id
     * @type {string}
     * @memberof InternalAdminApiUpdateOpsCostItem
     */
    readonly id: string

    /**
     * 
     * @type {OpsCostItemInputDto}
     * @memberof InternalAdminApiUpdateOpsCostItem
     */
    readonly opsCostItemInputDto: OpsCostItemInputDto
}

/**
 * Request parameters for updateShopNumbering operation in InternalAdminApi.
 * @export
 * @interface InternalAdminApiUpdateShopNumberingRequest
 */
export interface InternalAdminApiUpdateShopNumberingRequest {
    /**
     * Shop id
     * @type {string}
     * @memberof InternalAdminApiUpdateShopNumbering
     */
    readonly shopId: string

    /**
     * 
     * @type {string}
     * @memberof InternalAdminApiUpdateShopNumbering
     */
    readonly xOpsShopAccess: string

    /**
     * 
     * @type {UpdateShopNumberingDto}
     * @memberof InternalAdminApiUpdateShopNumbering
     */
    readonly updateShopNumberingDto: UpdateShopNumberingDto
}

/**
 * InternalAdminApi - object-oriented interface
 * @export
 * @class InternalAdminApi
 * @extends {BaseAPI}
 */
export class InternalAdminApi extends BaseAPI implements InternalAdminApiInterface {
    /**
     * 
     * @summary Archive a canned response (audited)
     * @param {InternalAdminApiArchiveCannedResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public archiveCannedResponse(requestParameters: InternalAdminApiArchiveCannedResponseRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).archiveCannedResponse(requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches the order from Shopify, runs the standard invoice creation pipeline (same calculation audit, same PDF generation), consumes the supplied invoice number, and writes an OperatorAuditLog row. Operator-only.
     * @summary Backfill an invoice for an order whose webhook was lost
     * @param {InternalAdminApiBackfillInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public backfillInvoice(requestParameters: InternalAdminApiBackfillInvoiceRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).backfillInvoice(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.backfillInvoiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates one in-app Alert per targeted shop, rendered in that shop’s Shop.locale from operator-supplied per-locale copy. Deduped by `broadcast:<broadcastKey>`; supports a dry run. Operator-only.
     * @summary Broadcast a custom system alert to merchants, in each shop’s language
     * @param {InternalAdminApiBroadcastAlertRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public broadcastAlert(requestParameters: InternalAdminApiBroadcastAlertRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).broadcastAlert(requestParameters.broadcastAlertDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a month’s rate (audited)
     * @param {InternalAdminApiClearOpsFxRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public clearOpsFxRate(requestParameters: InternalAdminApiClearOpsFxRateRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).clearOpsFxRate(requestParameters.month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a canned response (audited)
     * @param {InternalAdminApiCreateCannedResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public createCannedResponse(requestParameters: InternalAdminApiCreateCannedResponseRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).createCannedResponse(requestParameters.createCannedResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save a new email signature (audited)
     * @param {InternalAdminApiCreateEmailSignatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public createEmailSignature(requestParameters: InternalAdminApiCreateEmailSignatureRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).createEmailSignature(requestParameters.createEmailSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an operator (audited) — returns a one-time password
     * @param {InternalAdminApiCreateOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public createOperator(requestParameters: InternalAdminApiCreateOperatorRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).createOperator(requestParameters.createOperatorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record a cash balance (audited)
     * @param {InternalAdminApiCreateOpsCashBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public createOpsCashBalance(requestParameters: InternalAdminApiCreateOpsCashBalanceRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).createOpsCashBalance(requestParameters.opsCashBalanceInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a cost item (audited)
     * @param {InternalAdminApiCreateOpsCostItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public createOpsCostItem(requestParameters: InternalAdminApiCreateOpsCostItemRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).createOpsCostItem(requestParameters.opsCostItemInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies to subscriptions created AFTER this point only — the discount rides appSubscriptionCreate.
     * @summary Create a voucher code (audited)
     * @param {InternalAdminApiCreateOpsVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public createOpsVoucher(requestParameters: InternalAdminApiCreateOpsVoucherRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).createOpsVoucher(requestParameters.createVoucherRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stops new redemptions. Subscriptions that already carry the discount keep it. The code is never deleted: its usage rows would cascade away.
     * @summary Deactivate a voucher code (audited)
     * @param {InternalAdminApiDeactivateOpsVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public deactivateOpsVoucher(requestParameters: InternalAdminApiDeactivateOpsVoucherRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).deactivateOpsVoucher(requestParameters.id, requestParameters.deactivateVoucherRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a saved email signature (audited)
     * @param {InternalAdminApiDeleteEmailSignatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public deleteEmailSignature(requestParameters: InternalAdminApiDeleteEmailSignatureRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).deleteEmailSignature(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a cash balance (audited)
     * @param {InternalAdminApiDeleteOpsCashBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public deleteOpsCashBalance(requestParameters: InternalAdminApiDeleteOpsCashBalanceRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).deleteOpsCashBalance(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For mistakes. A cancelled cost gets an end month instead, so past months stay.
     * @summary Delete a cost item (audited)
     * @param {InternalAdminApiDeleteOpsCostItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public deleteOpsCostItem(requestParameters: InternalAdminApiDeleteOpsCostItemRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).deleteOpsCostItem(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Traces the order through webhook events, attention items, durable failed jobs and its documents, reads the shop state and the order from Shopify, and returns one verdict token plus exactly one next action for the invoice family and for the refund/cancellation family. Writes an OperatorAuditLog row (order.diagnosis.view).
     * @summary Diagnose why an order has or lacks its invoice, credit note or Storno
     * @param {InternalAdminApiDiagnoseOpsOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public diagnoseOpsOrder(requestParameters: InternalAdminApiDiagnoseOpsOrderRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).diagnoseOpsOrder(requestParameters.shopId, requestParameters.order, requestParameters.xOpsShopAccess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable an operator (audited)
     * @param {InternalAdminApiDisableOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public disableOperator(requestParameters: InternalAdminApiDisableOperatorRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).disableOperator(requestParameters.username, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The stored bytes, decrypted, exactly as archived. Writes document.pdf.download to the operator audit log first.
     * @summary Download a document’s archived PDF (audited)
     * @param {InternalAdminApiDownloadOpsShopDocumentPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public downloadOpsShopDocumentPdf(requestParameters: InternalAdminApiDownloadOpsShopDocumentPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).downloadOpsShopDocumentPdf(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.kind, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-enable an operator (audited)
     * @param {InternalAdminApiEnableOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public enableOperator(requestParameters: InternalAdminApiEnableOperatorRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).enableOperator(requestParameters.username, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Writes a durable OperatorAuditLog row, then re-checks each order against fresh data with the gap predicate and mints it through the single invoice writer (next sequential number, Rechnungsdatum = processed_at). Customer email is off unless sendCustomerEmail is true. At most 25 orders per call. Raises one merchant notice naming the period the new invoices are dated in.
     * @summary Mint invoices for previewed orders (audited)
     * @param {InternalAdminApiExecuteOpsPeriodBackfillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public executeOpsPeriodBackfill(requestParameters: InternalAdminApiExecuteOpsPeriodBackfillRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).executeOpsPeriodBackfill(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.periodBackfillExecuteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calls Shopify appSubscriptionTrialExtend for the shop\'s ACTIVE subscription while it is still in trial, at most 30 days per action. Writes the audit row before Shopify is called. A Shopify refusal (userErrors) is returned with extended=false, not thrown.
     * @summary Extend a running trial (audited)
     * @param {InternalAdminApiExtendOpsShopTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public extendOpsShopTrial(requestParameters: InternalAdminApiExtendOpsShopTrialRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).extendOpsShopTrial(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.trialExtensionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read one operator audit entry including its payload
     * @param {InternalAdminApiGetOperatorAuditEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getOperatorAuditEntry(requestParameters: InternalAdminApiGetOperatorAuditEntryRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getOperatorAuditEntry(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * EUR, accrual. Default range: the last 12 months including the running one; at most 36 months.
     * @summary Operations report: P&L, SaaS metrics, unit economics, plan, runway
     * @param {InternalAdminApiGetOpsFinanceReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getOpsFinanceReport(requestParameters: InternalAdminApiGetOpsFinanceReportRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getOpsFinanceReport(requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The snapshot the collector builds every 15 s. Poll at most every 15 s; it never changes faster.
     * @summary Infrastructure: nodes, Load Balancer, database connection budget
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getOpsInfrastructure(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getOpsInfrastructure(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Partner API mirror status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getOpsPartnerSyncStatus(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getOpsPartnerSyncStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Local subscription (both slots, cap, trial), trial-extension eligibility, TrialHistory, recent billing cycles, failed usage records, redeemed vouchers, subscription transition audit and earlier operator billing actions. DB only.
     * @summary Read a shop\'s billing detail
     * @param {InternalAdminApiGetOpsShopBillingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getOpsShopBilling(requestParameters: InternalAdminApiGetOpsShopBillingRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getOpsShopBilling(requestParameters.shopId, requestParameters.xOpsShopAccess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Settings summary and lock state (no secrets), every Steuerberater invite (never the token hash), every export schedule with its recipients and their confirmation state — distinguishing a double-opt-in confirmation from a recipient the Kanzlei’s finalise created CONFIRMED — and the latest DATEV EXTF export jobs.
     * @summary Read a shop\'s DATEV invite, export recipients and last exports
     * @param {InternalAdminApiGetOpsShopDatevRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getOpsShopDatev(requestParameters: InternalAdminApiGetOpsShopDatevRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getOpsShopDatev(requestParameters.shopId, requestParameters.xOpsShopAccess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Identity, subscription, contract acceptance, setup, Shopify scope approval, open alerts and attention items, recent webhooks, documents, exports and tickets. Sections that cannot be read are null and named in `unavailable`.
     * @summary Read a shop file
     * @param {InternalAdminApiGetOpsShopFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getOpsShopFile(requestParameters: InternalAdminApiGetOpsShopFileRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getOpsShopFile(requestParameters.shopId, requestParameters.xOpsShopAccess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * queued while the worker runs it, then completed (the server accepted it — check your inbox) or failed (with the classified reason).
     * @summary Poll an SMTP test mail
     * @param {InternalAdminApiGetOpsShopSmtpTestStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getOpsShopSmtpTestStatus(requestParameters: InternalAdminApiGetOpsShopSmtpTestStatusRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getOpsShopSmtpTestStatus(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a shop’s document numbering state
     * @param {InternalAdminApiGetShopNumberingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public getShopNumbering(requestParameters: InternalAdminApiGetShopNumberingRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).getShopNumbering(requestParameters.shopId, requestParameters.xOpsShopAccess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change an operator password — returns a fresh bearer token
     * @param {InternalAdminApiInternalAdminControllerChangePasswordV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerChangePasswordV1(requestParameters: InternalAdminApiInternalAdminControllerChangePasswordV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerChangePasswordV1(requestParameters.changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Discard all failed jobs in a queue (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerDiscardAllV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerDiscardAllV1(requestParameters: InternalAdminApiInternalAdminControllerDiscardAllV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerDiscardAllV1(requestParameters.name, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Discard (delete) a specific job (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerDiscardJobV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerDiscardJobV1(requestParameters: InternalAdminApiInternalAdminControllerDiscardJobV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerDiscardJobV1(requestParameters.name, requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all queue statistics and health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerGetAllQueuesV1(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerGetAllQueuesV1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get full job detail including stacktrace
     * @param {InternalAdminApiInternalAdminControllerGetJobV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerGetJobV1(requestParameters: InternalAdminApiInternalAdminControllerGetJobV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerGetJobV1(requestParameters.name, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List jobs by state with pagination
     * @param {InternalAdminApiInternalAdminControllerGetJobsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerGetJobsV1(requestParameters: InternalAdminApiInternalAdminControllerGetJobsV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerGetJobsV1(requestParameters.name, requestParameters.shopId, requestParameters.search, requestParameters.limit, requestParameters.page, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get rolling 24h metrics history for charts
     * @param {InternalAdminApiInternalAdminControllerGetMetricsHistoryV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerGetMetricsHistoryV1(requestParameters: InternalAdminApiInternalAdminControllerGetMetricsHistoryV1Request = {}, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerGetMetricsHistoryV1(requestParameters.minutes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the persistent FailedJob table (survives BullMQ removeOnFail eviction). Unresolved-only by default. Operator-only.
     * @summary List durable terminally-failed jobs
     * @param {InternalAdminApiInternalAdminControllerListFailedJobsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerListFailedJobsV1(requestParameters: InternalAdminApiInternalAdminControllerListFailedJobsV1Request = {}, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerListFailedJobsV1(requestParameters.queueName, requestParameters.shopId, requestParameters.includeResolved, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin login — returns a signed bearer token
     * @param {InternalAdminApiInternalAdminControllerLoginV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerLoginV1(requestParameters: InternalAdminApiInternalAdminControllerLoginV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerLoginV1(requestParameters.loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pause a queue (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerPauseV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerPauseV1(requestParameters: InternalAdminApiInternalAdminControllerPauseV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerPauseV1(requestParameters.name, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve (clear) a durable failed-job record (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerResolveFailedJobV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerResolveFailedJobV1(requestParameters: InternalAdminApiInternalAdminControllerResolveFailedJobV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerResolveFailedJobV1(requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resume a paused queue (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerResumeV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerResumeV1(requestParameters: InternalAdminApiInternalAdminControllerResumeV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerResumeV1(requestParameters.name, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry all failed jobs in a queue (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerRetryAllV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerRetryAllV1(requestParameters: InternalAdminApiInternalAdminControllerRetryAllV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerRetryAllV1(requestParameters.name, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry a specific job (audited, reason required)
     * @param {InternalAdminApiInternalAdminControllerRetryJobV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerRetryJobV1(requestParameters: InternalAdminApiInternalAdminControllerRetryJobV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerRetryJobV1(requestParameters.name, requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches the live subscription from Shopify Admin API and replays the webhook update handler to reconcile local DB. Operator-only (HMAC token from /internal-admin/auth/login).
     * @summary Force-sync subscription from Shopify
     * @param {InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public internalAdminControllerSyncSubscriptionFromShopifyV1(requestParameters: InternalAdminApiInternalAdminControllerSyncSubscriptionFromShopifyV1Request, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).internalAdminControllerSyncSubscriptionFromShopifyV1(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Active snippets by default; includeArchived adds archived ones. A category returns the snippets for that ticket category plus those that fit any. Shipped defaults that are missing are inserted first; an operator-edited default is never overwritten.
     * @summary List canned responses
     * @param {InternalAdminApiListCannedResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listCannedResponses(requestParameters: InternalAdminApiListCannedResponsesRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listCannedResponses(requestParameters.includeArchived, requestParameters.category, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List saved email signatures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listEmailSignatures(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listEmailSignatures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Filter by operator, action, shop domain and date. Payloads are not included — open one entry to read its payload (that read is itself audited).
     * @summary List operator audit entries
     * @param {InternalAdminApiListOperatorAuditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOperatorAudit(requestParameters: InternalAdminApiListOperatorAuditRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOperatorAudit(requestParameters.operator, requestParameters.action, requestParameters.shopDomain, requestParameters.from, requestParameters.to, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List operators
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOperators(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOperators(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List plan figures of a year
     * @param {InternalAdminApiListOpsBudgetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOpsBudgets(requestParameters: InternalAdminApiListOpsBudgetsRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOpsBudgets(requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List cash balances
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOpsCashBalances(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOpsCashBalances(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List cost items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOpsCostItems(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOpsCostItems(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List stored USD→EUR month rates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOpsFxRates(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOpsFxRates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Newest first across invoices, credit notes and cancellation invoices, 25 per page. With q, the support document lookup (document number, order name or order id) — unpaged, capped, and `truncated` says so.
     * @summary List or search a shop’s documents
     * @param {InternalAdminApiListOpsShopDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOpsShopDocuments(requestParameters: InternalAdminApiListOpsShopDocumentsRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOpsShopDocuments(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.q, requestParameters.kind, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Document and export mail only — `notLogged` names the mail that never creates a row. SENT means the relay accepted the message, not that it arrived; bounces are not recorded.
     * @summary Read a shop’s email delivery log
     * @param {InternalAdminApiListOpsShopEmailLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOpsShopEmailLog(requestParameters: InternalAdminApiListOpsShopEmailLogRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOpsShopEmailLog(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.recipient, requestParameters.status, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shop identity, subscription id and date only. onCurrentSubscription tells whether the discount is still on the shop’s subscription.
     * @summary List the shops that redeemed a voucher code
     * @param {InternalAdminApiListOpsVoucherUsagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOpsVoucherUsages(requestParameters: InternalAdminApiListOpsVoucherUsagesRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOpsVoucherUsages(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Newest first, with the currentUsage counter AND the usage-row count (both can under-count). Fixed amounts are in billingCurrency (USD).
     * @summary List voucher codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public listOpsVouchers(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).listOpsVouchers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Writes an OperatorAuditLog row with the reason or the ticket, and returns a grant valid for two hours. Every read of the shop requires the grant in the X-Ops-Shop-Access header.
     * @summary Open a shop with a reason (audited)
     * @param {InternalAdminApiOpenOpsShopAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public openOpsShopAccess(requestParameters: InternalAdminApiOpenOpsShopAccessRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).openOpsShopAccess(requestParameters.shopId, requestParameters.shopAccessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the paid orders in the period that the daily reconciliation would call a gap (the SAME predicate), the orders it leaves alone grouped by reason, whether the scan was truncated, and the window actually scanned (clamped to Shopify’s 60-day read window and to the invoicing anchor). Returns a preview token that arms execute for 15 minutes.
     * @summary Preview a period backfill (dry run)
     * @param {InternalAdminApiPreviewOpsPeriodBackfillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public previewOpsPeriodBackfill(requestParameters: InternalAdminApiPreviewOpsPeriodBackfillRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).previewOpsPeriodBackfill(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.periodBackfillPreviewRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The next two free invoice numbers (Storno, then the new invoice) and the refusal the reissue would answer with. Reserves nothing; another document minted in between moves the numbers.
     * @summary Preview a reissue: the numbers it would draw and any refusal
     * @param {InternalAdminApiPreviewOpsShopInvoiceReissueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public previewOpsShopInvoiceReissue(requestParameters: InternalAdminApiPreviewOpsShopInvoiceReissueRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).previewOpsShopInvoiceReissue(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only for a document with NO stored PDF. An archived PDF is never re-rendered (§147 AO) — resend it instead.
     * @summary Regenerate a missing PDF (audited)
     * @param {InternalAdminApiRegenerateOpsShopDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public regenerateOpsShopDocument(requestParameters: InternalAdminApiRegenerateOpsShopDocumentRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).regenerateOpsShopDocument(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.kind, requestParameters.documentId, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Re-reads the order from Shopify, writes a Stornorechnung for the ACTIVE immutable invoice and a new invoice through the normal correction pipeline, in one transaction and the gapless sequence. Works for a document that was never emailed (CREATED with an archived PDF). An optional customer VAT ID is format-checked, stored on the customer and printed on the new invoice. The Shopify order is never changed. Both documents then go through the normal PDF and email jobs.
     * @summary Reissue an invoice: Storno plus a new invoice from the current order (audited)
     * @param {InternalAdminApiReissueOpsShopInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public reissueOpsShopInvoice(requestParameters: InternalAdminApiReissueOpsShopInvoiceRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).reissueOpsShopInvoice(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.documentId, requestParameters.opsDocumentReissueDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Same path as the merchant\'s resend: mints a NEW token, so the Kanzlei\'s previous link stops working even if this send fails. Only the shop\'s newest PENDING invite is resendable. A successful send closes DATEV_INVITE_UNDELIVERED by itself. Rate-limited per shop.
     * @summary Resend the pending Steuerberater invite (audited)
     * @param {InternalAdminApiResendOpsDatevInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public resendOpsDatevInvite(requestParameters: InternalAdminApiResendOpsDatevInviteRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).resendOpsDatevInvite(requestParameters.shopId, requestParameters.inviteId, requestParameters.xOpsShopAccess, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Same path as the merchant\'s resend: rotates the confirmation token, so the recipient\'s earlier link stops working. PENDING and EXPIRED recipients only — a CONFIRMED one would be reset to pending, a REJECTED one declined. Rate-limited per shop.
     * @summary Resend an export recipient\'s confirmation email (audited)
     * @param {InternalAdminApiResendOpsRecipientConfirmationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public resendOpsRecipientConfirmation(requestParameters: InternalAdminApiResendOpsRecipientConfirmationRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).resendOpsRecipientConfirmation(requestParameters.shopId, requestParameters.recipientId, requestParameters.xOpsShopAccess, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Queues the merchant’s own resend of the ARCHIVED PDF. recipientOverride needs the ticketId of a support ticket of this shop. Refused for a document the shop is holding for its own first send (automatic sending off). A failed send still raises the merchant’s own failure alert.
     * @summary Resend a document email (audited)
     * @param {InternalAdminApiResendOpsShopDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public resendOpsShopDocument(requestParameters: InternalAdminApiResendOpsShopDocumentRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).resendOpsShopDocument(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.kind, requestParameters.documentId, requestParameters.opsDocumentResendDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset an operator password (audited) — returns a one-time password
     * @param {InternalAdminApiResetOperatorPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public resetOperatorPassword(requestParameters: InternalAdminApiResetOperatorPasswordRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).resetOperatorPassword(requestParameters.username, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restore an archived canned response (audited)
     * @param {InternalAdminApiRestoreCannedResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public restoreCannedResponse(requestParameters: InternalAdminApiRestoreCannedResponseRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).restoreCannedResponse(requestParameters.id, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns identity only (domain, name, which field matched). Opening a shop needs a reason — see openOpsShopAccess.
     * @summary Find shops by domain, name or email
     * @param {InternalAdminApiSearchOpsShopsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public searchOpsShops(requestParameters: InternalAdminApiSearchOpsShopsRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).searchOpsShops(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The worker sends an export-shaped test through the merchant’s SMTP to YOUR operator address — never to anyone else, and without the connection probe that writes an error onto the merchant’s settings. Not applicable on our fallback relay or without a complete SMTP configuration.
     * @summary Send an SMTP test mail to yourself (audited)
     * @param {InternalAdminApiSendOpsShopSmtpTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public sendOpsShopSmtpTest(requestParameters: InternalAdminApiSendOpsShopSmtpTestRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).sendOpsShopSmtpTest(requestParameters.xOpsShopAccess, requestParameters.shopId, requestParameters.operatorReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A null amount removes the figure. Returns the whole year.
     * @summary Set or clear one plan figure (audited)
     * @param {InternalAdminApiSetOpsBudgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public setOpsBudget(requestParameters: InternalAdminApiSetOpsBudgetRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).setOpsBudget(requestParameters.opsBudgetInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stored as MANUAL; an ECB fetch never replaces it.
     * @summary Override a month’s USD→EUR rate (audited)
     * @param {InternalAdminApiSetOpsFxRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public setOpsFxRate(requestParameters: InternalAdminApiSetOpsFxRateRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).setOpsFxRate(requestParameters.month, requestParameters.opsFxRateInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Runs in the background; poll the status. Idempotent — a re-pull changes nothing.
     * @summary Pull the Partner API now
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public startOpsPartnerSync(options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).startOpsPartnerSync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
     * @summary Edit a canned response (audited, optimistic concurrency)
     * @param {InternalAdminApiUpdateCannedResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public updateCannedResponse(requestParameters: InternalAdminApiUpdateCannedResponseRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).updateCannedResponse(requestParameters.id, requestParameters.updateCannedResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the whole content. expectedUpdatedAt must be the updatedAt the operator edited; a newer version answers 409 instead of being overwritten.
     * @summary Save an edited email signature (audited, optimistic concurrency)
     * @param {InternalAdminApiUpdateEmailSignatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public updateEmailSignature(requestParameters: InternalAdminApiUpdateEmailSignatureRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).updateEmailSignature(requestParameters.id, requestParameters.updateEmailSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an operator profile (audited)
     * @param {InternalAdminApiUpdateOperatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public updateOperator(requestParameters: InternalAdminApiUpdateOperatorRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).updateOperator(requestParameters.username, requestParameters.updateOperatorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restates every month the item ran in. To record a price change, end the item and start a new one.
     * @summary Edit a cost item (audited)
     * @param {InternalAdminApiUpdateOpsCostItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public updateOpsCostItem(requestParameters: InternalAdminApiUpdateOpsCostItemRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).updateOpsCostItem(requestParameters.id, requestParameters.opsCostItemInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change a shop’s onboarding-frozen document numbering
     * @param {InternalAdminApiUpdateShopNumberingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalAdminApi
     */
    public updateShopNumbering(requestParameters: InternalAdminApiUpdateShopNumberingRequest, options?: RawAxiosRequestConfig) {
        return InternalAdminApiFp(this.configuration).updateShopNumbering(requestParameters.shopId, requestParameters.xOpsShopAccess, requestParameters.updateShopNumberingDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum DownloadOpsShopDocumentPdfKindEnum {
    Invoice = 'invoice',
    CreditNote = 'creditNote',
    Cancellation = 'cancellation'
}
/**
  * @export
  * @enum {string}
  */
export enum InternalAdminControllerGetJobsV1StateEnum {
    Waiting = 'waiting',
    Active = 'active',
    Completed = 'completed',
    Failed = 'failed',
    Delayed = 'delayed'
}
/**
  * @export
  * @enum {string}
  */
export enum InternalAdminControllerListFailedJobsV1QueueNameEnum {
    InvoiceProcessing = 'invoice-processing',
    ExportProcessing = 'export-processing',
    WebhookProcessing = 'webhook-processing',
    DataRetention = 'data-retention'
}
/**
  * @export
  * @enum {string}
  */
export enum ListCannedResponsesCategoryEnum {
    Question = 'QUESTION',
    Bug = 'BUG',
    FeatureRequest = 'FEATURE_REQUEST',
    Feedback = 'FEEDBACK',
    Billing = 'BILLING',
    TaxCompliance = 'TAX_COMPLIANCE',
    DataExport = 'DATA_EXPORT',
    Onboarding = 'ONBOARDING',
    Other = 'OTHER'
}
/**
  * @export
  * @enum {string}
  */
export enum RegenerateOpsShopDocumentKindEnum {
    Invoice = 'invoice',
    CreditNote = 'creditNote',
    Cancellation = 'cancellation'
}
/**
  * @export
  * @enum {string}
  */
export enum ResendOpsShopDocumentKindEnum {
    Invoice = 'invoice',
    CreditNote = 'creditNote',
    Cancellation = 'cancellation'
}
